// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../node_modules/@bcgov/bc-sans/fonts/BCSans-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27oklch%2855.1%25 0.027 264.364%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
@layer base {
  @font-face {
    font-family: "BCSans";
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  }
  @font-face {
    font-family: "BCSans";
    font-style: italic;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  }
  @font-face {
    font-family: "BCSans";
    font-style: normal;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  }
  @font-face {
    font-family: "BCSans";
    font-style: italic;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  }
  @font-face {
    font-family: "BCSans";
    font-style: normal;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  }
  @font-face {
    font-family: "BCSans";
    font-style: italic;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  }
}
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: 'BCSans', sans-serif;
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-blue-300: oklch(80.9% 0.105 251.813);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-blue-700: oklch(48.8% 0.243 264.376);
    --color-blue-900: oklch(37.9% 0.146 265.522);
    --color-purple-600: oklch(55.8% 0.288 302.321);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-4xl: 56rem;
    --container-5xl: 64rem;
    --container-6xl: 72rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --text-6xl: 3.75rem;
    --text-6xl--line-height: 1;
    --text-7xl: 4.5rem;
    --text-7xl--line-height: 1;
    --font-weight-light: 300;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-extrabold: 800;
    --font-weight-black: 900;
    --tracking-tight: -0.025em;
    --tracking-wide: 0.025em;
    --leading-tight: 1.25;
    --radius-xs: 0.125rem;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-3xl: 1.5rem;
    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);
    --ease-in: cubic-bezier(0.4, 0, 1, 1);
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --aspect-video: 16 / 9;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-blumine-50: #f0f9fb;
    --color-blumine-100: #daeef3;
    --color-blumine-200: #badee7;
    --color-blumine-300: #89c5d7;
    --color-blumine-400: #52a3be;
    --color-blumine-500: #3787a3;
    --color-blumine-600: #306d8a;
    --color-blumine-700: #2d5b72;
    --color-blumine-800: #2c4c5e;
    --color-blumine-900: #284151;
    --color-scarlet-50: #fff0f1;
    --color-scarlet-100: #ffdcdf;
    --color-scarlet-200: #ffc0c6;
    --color-scarlet-400: #ff5665;
    --color-scarlet-500: #ff2236;
    --color-scarlet-600: #ff0219;
    --color-scarlet-700: #d80013;
    --color-scarlet-800: #b40212;
    --color-scarlet-900: #920a16;
    --color-charcoal-50: #f5f5f6;
    --color-charcoal-100: #e6e6e7;
    --color-charcoal-200: #cfd0d2;
    --color-charcoal-300: #aeafb2;
    --color-charcoal-400: #85868b;
    --color-charcoal-500: #6a6b70;
    --color-charcoal-600: #5a5b60;
    --color-charcoal-700: #4d4d51;
    --color-charcoal-800: #434347;
    --color-charcoal-900: #313133;
    --color-jade-50: #effaf6;
    --color-jade-100: #d9f2e6;
    --color-jade-200: #b6e4d1;
    --color-jade-400: #53b494;
    --color-jade-500: #2c876d;
    --color-jade-600: #227962;
    --color-jade-700: #1b6150;
    --color-jade-800: #184d40;
    --color-jade-900: #144036;
    --color-ochre-50: #fcf9ee;
    --color-ochre-100: #f5edd0;
    --color-ochre-200: #ebd99c;
    --color-ochre-400: #daad45;
    --color-ochre-500: #d1912f;
    --color-ochre-600: #c37829;
    --color-ochre-700: #995424;
    --color-ochre-800: #7e4322;
    --color-ochre-900: #68381f;
    --animate-pulse-blur: pulse-blur 2.5s linear infinite;
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring:where(:not(iframe)) {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .btn-lg-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    & svg {
      margin: 0px;
      display: block;
      height: 100%;
      width: 100%;
      padding: 0px;
      vertical-align: middle;
    }
    height: calc(var(--spacing) * 14);
    width: calc(var(--spacing) * 14);
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 16);
    }
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 16);
    }
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 12);
    }
    @media (width >= 80rem) {
      width: calc(var(--spacing) * 12);
    }
    & svg {
      height: calc(var(--spacing) * 7);
      width: calc(var(--spacing) * 7);
      fill: currentcolor;
    }
  }
  .btn-md-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    & svg {
      margin: 0px;
      display: block;
      height: 100%;
      width: 100%;
      padding: 0px;
      vertical-align: middle;
    }
    height: calc(var(--spacing) * 12);
    width: calc(var(--spacing) * 12);
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 14);
    }
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 14);
    }
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 10);
    }
    @media (width >= 80rem) {
      width: calc(var(--spacing) * 10);
    }
    & svg {
      height: calc(var(--spacing) * 6);
      width: calc(var(--spacing) * 6);
      fill: currentcolor;
    }
  }
  .btn-sm-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    & svg {
      margin: 0px;
      display: block;
      height: 100%;
      width: 100%;
      padding: 0px;
      vertical-align: middle;
    }
    height: calc(var(--spacing) * 11);
    width: calc(var(--spacing) * 11);
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 8);
    }
    @media (width >= 80rem) {
      width: calc(var(--spacing) * 8);
    }
    & svg {
      height: calc(var(--spacing) * 5);
      width: calc(var(--spacing) * 5);
      fill: currentcolor;
      @media (width >= 80rem) {
        height: calc(var(--spacing) * 3);
      }
      @media (width >= 80rem) {
        width: calc(var(--spacing) * 3);
      }
    }
  }
  .btn-xl-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    & svg {
      margin: 0px;
      display: block;
      height: 100%;
      width: 100%;
      padding: 0px;
      vertical-align: middle;
    }
    height: calc(var(--spacing) * 16);
    width: calc(var(--spacing) * 16);
    @media (width >= 48rem) {
      height: calc(var(--spacing) * 20);
    }
    @media (width >= 48rem) {
      width: calc(var(--spacing) * 20);
    }
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 14);
    }
    @media (width >= 80rem) {
      width: calc(var(--spacing) * 14);
    }
    & svg {
      height: calc(var(--spacing) * 8);
      width: calc(var(--spacing) * 8);
      fill: currentcolor;
    }
  }
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: 0px;
  }
  .inset-x-0 {
    inset-inline: 0px;
  }
  .inset-y-0 {
    inset-block: 0px;
  }
  .-top-7 {
    top: calc(var(--spacing) * -7);
  }
  .-top-16 {
    top: calc(var(--spacing) * -16);
  }
  .top-0 {
    top: 0px;
  }
  .top-1 {
    top: var(--spacing);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-5 {
    top: calc(var(--spacing) * 5);
  }
  .top-6 {
    top: calc(var(--spacing) * 6);
  }
  .top-7 {
    top: calc(var(--spacing) * 7);
  }
  .top-10 {
    top: calc(var(--spacing) * 10);
  }
  .top-12 {
    top: calc(var(--spacing) * 12);
  }
  .top-14 {
    top: calc(var(--spacing) * 14);
  }
  .top-20 {
    top: calc(var(--spacing) * 20);
  }
  .right-0 {
    right: 0px;
  }
  .right-1 {
    right: var(--spacing);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-5 {
    right: calc(var(--spacing) * 5);
  }
  .right-6 {
    right: calc(var(--spacing) * 6);
  }
  .right-7 {
    right: calc(var(--spacing) * 7);
  }
  .-bottom-1 {
    bottom: calc(var(--spacing) * -1);
  }
  .-bottom-5 {
    bottom: calc(var(--spacing) * -5);
  }
  .-bottom-12 {
    bottom: calc(var(--spacing) * -12);
  }
  .bottom-0 {
    bottom: 0px;
  }
  .bottom-1 {
    bottom: var(--spacing);
  }
  .bottom-2 {
    bottom: calc(var(--spacing) * 2);
  }
  .bottom-5 {
    bottom: calc(var(--spacing) * 5);
  }
  .bottom-9 {
    bottom: calc(var(--spacing) * 9);
  }
  .bottom-24 {
    bottom: calc(var(--spacing) * 24);
  }
  .-left-8 {
    left: calc(var(--spacing) * -8);
  }
  .left-0 {
    left: 0px;
  }
  .left-1 {
    left: var(--spacing);
  }
  .left-1\\/2 {
    left: calc(1 / 2 * 100%);
  }
  .left-2 {
    left: calc(var(--spacing) * 2);
  }
  .-z-10 {
    z-index: calc(10 * -1);
  }
  .z-0 {
    z-index: 0;
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-30 {
    z-index: 30;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .col-span-1 {
    grid-column: span 1 / span 1;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-3 {
    grid-column: span 3 / span 3;
  }
  .col-span-4 {
    grid-column: span 4 / span 4;
  }
  .col-span-5 {
    grid-column: span 5 / span 5;
  }
  .col-span-6 {
    grid-column: span 6 / span 6;
  }
  .col-span-7 {
    grid-column: span 7 / span 7;
  }
  .col-span-8 {
    grid-column: span 8 / span 8;
  }
  .col-span-11 {
    grid-column: span 11 / span 11;
  }
  .col-span-12 {
    grid-column: span 12 / span 12;
  }
  .col-span-16 {
    grid-column: span 16 / span 16;
  }
  .row-auto {
    grid-row: auto;
  }
  .row-span-1 {
    grid-row: span 1 / span 1;
  }
  .row-span-5 {
    grid-row: span 5 / span 5;
  }
  .float-right {
    float: right;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .m-1 {
    margin: var(--spacing);
  }
  .m-2 {
    margin: calc(var(--spacing) * 2);
  }
  .m-3 {
    margin: calc(var(--spacing) * 3);
  }
  .m-4 {
    margin: calc(var(--spacing) * 4);
  }
  .m-5 {
    margin: calc(var(--spacing) * 5);
  }
  .m-6 {
    margin: calc(var(--spacing) * 6);
  }
  .m-auto {
    margin: auto;
  }
  .mx-0 {
    margin-inline: 0px;
  }
  .mx-0\\.5 {
    margin-inline: calc(var(--spacing) * 0.5);
  }
  .mx-1 {
    margin-inline: var(--spacing);
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2);
  }
  .mx-3 {
    margin-inline: calc(var(--spacing) * 3);
  }
  .mx-4 {
    margin-inline: calc(var(--spacing) * 4);
  }
  .mx-6 {
    margin-inline: calc(var(--spacing) * 6);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .wysiwyg {
    text-align: left;
    & h2 {
      margin-block: calc(var(--spacing) * 6);
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
      border-color: var(--color-charcoal-500);
      padding-block: calc(var(--spacing) * 5);
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
      --tw-font-weight: var(--font-weight-bold);
      font-weight: var(--font-weight-bold);
      color: var(--color-blumine-800);
    }
    & h3 {
      margin-block: calc(var(--spacing) * 4);
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
      --tw-font-weight: var(--font-weight-bold);
      font-weight: var(--font-weight-bold);
      color: var(--color-blumine-800);
    }
    & ol {
      list-style-type: decimal;
      padding-left: calc(var(--spacing) * 6);
    }
    & ul {
      list-style-type: disc;
      padding-left: calc(var(--spacing) * 6);
    }
    & div {
      margin-block: calc(var(--spacing) * 4);
    }
    & p {
      margin-block: calc(var(--spacing) * 4);
    }
    & a {
      color: var(--color-blue-600);
      text-decoration-line: underline;
      text-underline-offset: 2px;
      &:visited {
        color: var(--color-purple-600);
      }
    }
  }
  .my-1 {
    margin-block: var(--spacing);
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .my-4 {
    margin-block: calc(var(--spacing) * 4);
  }
  .my-5 {
    margin-block: calc(var(--spacing) * 5);
  }
  .my-6 {
    margin-block: calc(var(--spacing) * 6);
  }
  .my-7 {
    margin-block: calc(var(--spacing) * 7);
  }
  .my-8 {
    margin-block: calc(var(--spacing) * 8);
  }
  .-mt-4 {
    margin-top: calc(var(--spacing) * -4);
  }
  .-mt-5 {
    margin-top: calc(var(--spacing) * -5);
  }
  .-mt-6 {
    margin-top: calc(var(--spacing) * -6);
  }
  .-mt-10 {
    margin-top: calc(var(--spacing) * -10);
  }
  .mt-1 {
    margin-top: var(--spacing);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-10 {
    margin-top: calc(var(--spacing) * 10);
  }
  .mt-16 {
    margin-top: calc(var(--spacing) * 16);
  }
  .mt-24 {
    margin-top: calc(var(--spacing) * 24);
  }
  .mt-auto {
    margin-top: auto;
  }
  .-mr-1 {
    margin-right: calc(var(--spacing) * -1);
  }
  .mr-1 {
    margin-right: var(--spacing);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mr-3 {
    margin-right: calc(var(--spacing) * 3);
  }
  .mr-4 {
    margin-right: calc(var(--spacing) * 4);
  }
  .mr-5 {
    margin-right: calc(var(--spacing) * 5);
  }
  .mr-auto {
    margin-right: auto;
  }
  .-mb-14 {
    margin-bottom: calc(var(--spacing) * -14);
  }
  .mb-1 {
    margin-bottom: var(--spacing);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-7 {
    margin-bottom: calc(var(--spacing) * 7);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .mb-10 {
    margin-bottom: calc(var(--spacing) * 10);
  }
  .mb-11 {
    margin-bottom: calc(var(--spacing) * 11);
  }
  .mb-12 {
    margin-bottom: calc(var(--spacing) * 12);
  }
  .mb-20 {
    margin-bottom: calc(var(--spacing) * 20);
  }
  .-ml-4 {
    margin-left: calc(var(--spacing) * -4);
  }
  .-ml-7 {
    margin-left: calc(var(--spacing) * -7);
  }
  .ml-0\\.5 {
    margin-left: calc(var(--spacing) * 0.5);
  }
  .ml-1 {
    margin-left: var(--spacing);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-3 {
    margin-left: calc(var(--spacing) * 3);
  }
  .ml-4 {
    margin-left: calc(var(--spacing) * 4);
  }
  .ml-6 {
    margin-left: calc(var(--spacing) * 6);
  }
  .ml-10 {
    margin-left: calc(var(--spacing) * 10);
  }
  .ml-16 {
    margin-left: calc(var(--spacing) * 16);
  }
  .ml-auto {
    margin-left: auto;
  }
  .btn-lg {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    height: calc(var(--spacing) * 14);
    min-width: calc(var(--spacing) * 40);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 12);
    }
    @media (width >= 80rem) {
      min-width: calc(var(--spacing) * 52);
    }
    @media (width >= 80rem) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
    & svg {
      height: calc(var(--spacing) * 6.5);
      width: calc(var(--spacing) * 6.5);
      fill: currentcolor;
    }
  }
  .btn-md {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    height: calc(var(--spacing) * 11);
    min-width: calc(var(--spacing) * 32);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 10);
    }
    @media (width >= 80rem) {
      min-width: calc(var(--spacing) * 40);
    }
    @media (width >= 80rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    & svg {
      height: calc(var(--spacing) * 5);
      width: calc(var(--spacing) * 5);
      fill: currentcolor;
    }
  }
  .btn-sm {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    height: calc(var(--spacing) * 9);
    min-width: calc(var(--spacing) * 24);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 1.5);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 8);
    }
    @media (width >= 80rem) {
      min-width: calc(var(--spacing) * 32);
    }
    @media (width >= 80rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    & svg {
      height: calc(var(--spacing) * 4.5);
      width: calc(var(--spacing) * 4.5);
      fill: currentcolor;
    }
  }
  .btn-xl {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    height: calc(var(--spacing) * 16);
    min-width: calc(var(--spacing) * 52);
    padding-inline: calc(var(--spacing) * 5);
    padding-block: calc(var(--spacing) * 3);
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 14);
    }
    @media (width >= 80rem) {
      min-width: calc(var(--spacing) * 80);
    }
    @media (width >= 80rem) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
    & svg {
      height: calc(var(--spacing) * 8);
      width: calc(var(--spacing) * 8);
      fill: currentcolor;
    }
  }
  .btn-xs {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    height: calc(var(--spacing) * 7);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: var(--spacing);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 6);
    }
    @media (width >= 80rem) {
      min-width: calc(var(--spacing) * 24);
    }
    @media (width >= 80rem) {
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
    }
    & svg {
      height: calc(var(--spacing) * 3);
      width: calc(var(--spacing) * 3);
      fill: currentcolor;
    }
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .flow-root {
    display: flow-root;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .aspect-3\\/2 {
    aspect-ratio: 3/2;
  }
  .aspect-4\\/3 {
    aspect-ratio: 4/3;
  }
  .aspect-auto {
    aspect-ratio: auto;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .aspect-video {
    aspect-ratio: var(--aspect-video);
  }
  .size-5 {
    width: calc(var(--spacing) * 5);
    height: calc(var(--spacing) * 5);
  }
  .size-6 {
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
  }
  .size-8 {
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
  }
  .size-10 {
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
  }
  .size-12 {
    width: calc(var(--spacing) * 12);
    height: calc(var(--spacing) * 12);
  }
  .size-16 {
    width: calc(var(--spacing) * 16);
    height: calc(var(--spacing) * 16);
  }
  .size-18 {
    width: calc(var(--spacing) * 18);
    height: calc(var(--spacing) * 18);
  }
  .size-44 {
    width: calc(var(--spacing) * 44);
    height: calc(var(--spacing) * 44);
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .h-0 {
    height: 0px;
  }
  .h-1 {
    height: var(--spacing);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\/4 {
    height: calc(3 / 4 * 100%);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-15 {
    height: calc(var(--spacing) * 15);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-18 {
    height: calc(var(--spacing) * 18);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-28 {
    height: calc(var(--spacing) * 28);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-36 {
    height: calc(var(--spacing) * 36);
  }
  .h-40 {
    height: calc(var(--spacing) * 40);
  }
  .h-44 {
    height: calc(var(--spacing) * 44);
  }
  .h-48 {
    height: calc(var(--spacing) * 48);
  }
  .h-52 {
    height: calc(var(--spacing) * 52);
  }
  .h-54 {
    height: calc(var(--spacing) * 54);
  }
  .h-60 {
    height: calc(var(--spacing) * 60);
  }
  .h-64 {
    height: calc(var(--spacing) * 64);
  }
  .h-72 {
    height: calc(var(--spacing) * 72);
  }
  .h-80 {
    height: calc(var(--spacing) * 80);
  }
  .h-96 {
    height: calc(var(--spacing) * 96);
  }
  .h-\\[66vh\\] {
    height: 66vh;
  }
  .h-\\[80vh\\] {
    height: 80vh;
  }
  .h-\\[90vh\\] {
    height: 90vh;
  }
  .h-auto {
    height: auto;
  }
  .h-full {
    height: 100%;
  }
  .h-screen {
    height: 100vh;
  }
  .max-h-60 {
    max-height: calc(var(--spacing) * 60);
  }
  .max-h-68 {
    max-height: calc(var(--spacing) * 68);
  }
  .max-h-72 {
    max-height: calc(var(--spacing) * 72);
  }
  .max-h-78 {
    max-height: calc(var(--spacing) * 78);
  }
  .max-h-80 {
    max-height: calc(var(--spacing) * 80);
  }
  .max-h-96 {
    max-height: calc(var(--spacing) * 96);
  }
  .max-h-\\[80vh\\] {
    max-height: 80vh;
  }
  .max-h-\\[90vh\\] {
    max-height: 90vh;
  }
  .max-h-screen {
    max-height: 100vh;
  }
  .min-h-0 {
    min-height: 0px;
  }
  .min-h-5 {
    min-height: calc(var(--spacing) * 5);
  }
  .min-h-22 {
    min-height: calc(var(--spacing) * 22);
  }
  .min-h-36 {
    min-height: calc(var(--spacing) * 36);
  }
  .min-h-52 {
    min-height: calc(var(--spacing) * 52);
  }
  .min-h-220 {
    min-height: calc(var(--spacing) * 220);
  }
  .min-h-dvh {
    min-height: 100dvh;
  }
  .min-h-full {
    min-height: 100%;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-0 {
    width: 0px;
  }
  .w-1\\/2 {
    width: calc(1 / 2 * 100%);
  }
  .w-1\\/4 {
    width: calc(1 / 4 * 100%);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\/3 {
    width: calc(2 / 3 * 100%);
  }
  .w-2\\/6 {
    width: calc(2 / 6 * 100%);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\/4 {
    width: calc(3 / 4 * 100%);
  }
  .w-3\\/5 {
    width: calc(3 / 5 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-4\\/5 {
    width: calc(4 / 5 * 100%);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-7 {
    width: calc(var(--spacing) * 7);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-11 {
    width: calc(var(--spacing) * 11);
  }
  .w-11\\/12 {
    width: calc(11 / 12 * 100%);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-14 {
    width: calc(var(--spacing) * 14);
  }
  .w-15 {
    width: calc(var(--spacing) * 15);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-18 {
    width: calc(var(--spacing) * 18);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-28 {
    width: calc(var(--spacing) * 28);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-44 {
    width: calc(var(--spacing) * 44);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-52 {
    width: calc(var(--spacing) * 52);
  }
  .w-56 {
    width: calc(var(--spacing) * 56);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-80 {
    width: calc(var(--spacing) * 80);
  }
  .w-96 {
    width: calc(var(--spacing) * 96);
  }
  .w-\\[25vw\\] {
    width: 25vw;
  }
  .w-\\[50vw\\] {
    width: 50vw;
  }
  .w-\\[75vw\\] {
    width: 75vw;
  }
  .w-\\[90vw\\] {
    width: 90vw;
  }
  .w-\\[95vw\\] {
    width: 95vw;
  }
  .w-auto {
    width: auto;
  }
  .w-full {
    width: 100%;
  }
  .w-screen {
    width: 100vw;
  }
  .w-sm {
    width: var(--container-sm);
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-4xl {
    max-width: var(--container-4xl);
  }
  .max-w-5xl {
    max-width: var(--container-5xl);
  }
  .max-w-6xl {
    max-width: var(--container-6xl);
  }
  .max-w-7xl {
    max-width: var(--container-7xl);
  }
  .max-w-32 {
    max-width: calc(var(--spacing) * 32);
  }
  .max-w-72 {
    max-width: calc(var(--spacing) * 72);
  }
  .max-w-96 {
    max-width: calc(var(--spacing) * 96);
  }
  .max-w-\\[85vw\\] {
    max-width: 85vw;
  }
  .max-w-\\[378px\\] {
    max-width: 378px;
  }
  .max-w-\\[760px\\] {
    max-width: 760px;
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-max {
    max-width: max-content;
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-none {
    max-width: none;
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .max-w-xs {
    max-width: var(--container-xs);
  }
  .min-w-0 {
    min-width: 0px;
  }
  .min-w-3xl {
    min-width: var(--container-3xl);
  }
  .min-w-4xl {
    min-width: var(--container-4xl);
  }
  .min-w-30 {
    min-width: calc(var(--spacing) * 30);
  }
  .min-w-auto {
    min-width: auto;
  }
  .min-w-full {
    min-width: 100%;
  }
  .min-w-max {
    min-width: max-content;
  }
  .min-w-md {
    min-width: var(--container-md);
  }
  .min-w-screen {
    min-width: 100vw;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-none {
    flex: none;
  }
  .shrink {
    flex-shrink: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .table-auto {
    table-layout: auto;
  }
  .table-fixed {
    table-layout: fixed;
  }
  .border-separate {
    border-collapse: separate;
  }
  .border-spacing-y-4 {
    --tw-border-spacing-y: calc(var(--spacing) * 4);
    border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
  }
  .origin-top {
    transform-origin: top;
  }
  .origin-top-right {
    transform-origin: 100% 0;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-1 {
    --tw-translate-x: var(--spacing);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-6 {
    --tw-translate-x: calc(var(--spacing) * 6);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-0 {
    --tw-scale-x: 0%;
    --tw-scale-y: 0%;
    --tw-scale-z: 0%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-95 {
    --tw-scale-x: 95%;
    --tw-scale-y: 95%;
    --tw-scale-z: 95%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-100 {
    --tw-scale-x: 100%;
    --tw-scale-y: 100%;
    --tw-scale-z: 100%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .-rotate-6 {
    rotate: calc(6deg * -1);
  }
  .rotate-180 {
    rotate: 180deg;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-pulse-blur {
    animation: var(--animate-pulse-blur);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-text {
    cursor: text;
  }
  .touch-auto {
    touch-action: auto;
  }
  .resize-none {
    resize: none;
  }
  .snap-x {
    scroll-snap-type: x var(--tw-scroll-snap-strictness);
  }
  .snap-center {
    scroll-snap-align: center;
  }
  .snap-start {
    scroll-snap-align: start;
  }
  .list-inside {
    list-style-position: inside;
  }
  .list-outside {
    list-style-position: outside;
  }
  .list-decimal {
    list-style-type: decimal;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .appearance-none {
    appearance: none;
  }
  .columns-2 {
    columns: 2;
  }
  .columns-3 {
    columns: 3;
  }
  .columns-4 {
    columns: 4;
  }
  .break-inside-avoid-column {
    break-inside: avoid-column;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .grid-cols-16 {
    grid-template-columns: repeat(16, minmax(0, 1fr));
  }
  .grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .grid-rows-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .place-content-center {
    place-content: center;
  }
  .place-items-center {
    place-items: center;
  }
  .content-between {
    align-content: space-between;
  }
  .content-center {
    align-content: center;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .items-stretch {
    align-items: stretch;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-evenly {
    justify-content: space-evenly;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .justify-stretch {
    justify-content: stretch;
  }
  .justify-items-stretch {
    justify-items: stretch;
  }
  .gap-1 {
    gap: var(--spacing);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-7 {
    gap: calc(var(--spacing) * 7);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-10 {
    gap: calc(var(--spacing) * 10);
  }
  .gap-px {
    gap: 1px;
  }
  :where(.space-y-1 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(var(--spacing) * var(--tw-space-y-reverse));
    margin-block-end: calc(var(--spacing) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-2 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-3 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-4 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-5 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 5) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-6 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-7 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 7) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 7) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-8 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-10 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 10) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 10) * calc(1 - var(--tw-space-y-reverse)));
  }
  :where(.space-y-reverse > :not(:last-child)) {
    --tw-space-y-reverse: 1;
  }
  .gap-x-1\\.5 {
    column-gap: calc(var(--spacing) * 1.5);
  }
  .gap-x-2 {
    column-gap: calc(var(--spacing) * 2);
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3);
  }
  .gap-x-4 {
    column-gap: calc(var(--spacing) * 4);
  }
  .gap-x-6 {
    column-gap: calc(var(--spacing) * 6);
  }
  :where(.space-x-1 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(var(--spacing) * var(--tw-space-x-reverse));
    margin-inline-end: calc(var(--spacing) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-1\\.5 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-2 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-3 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 3) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-4 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-5 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 5) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-8 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 8) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-x-reverse)));
  }
  :where(.space-x-11 > :not(:last-child)) {
    --tw-space-x-reverse: 0;
    margin-inline-start: calc(calc(var(--spacing) * 11) * var(--tw-space-x-reverse));
    margin-inline-end: calc(calc(var(--spacing) * 11) * calc(1 - var(--tw-space-x-reverse)));
  }
  .gap-y-2 {
    row-gap: calc(var(--spacing) * 2);
  }
  .gap-y-4 {
    row-gap: calc(var(--spacing) * 4);
  }
  .gap-y-6 {
    row-gap: calc(var(--spacing) * 6);
  }
  .gap-y-8 {
    row-gap: calc(var(--spacing) * 8);
  }
  :where(.divide-x > :not(:last-child)) {
    --tw-divide-x-reverse: 0;
    border-inline-style: var(--tw-border-style);
    border-inline-start-width: calc(1px * var(--tw-divide-x-reverse));
    border-inline-end-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }
  :where(.divide-x-2 > :not(:last-child)) {
    --tw-divide-x-reverse: 0;
    border-inline-style: var(--tw-border-style);
    border-inline-start-width: calc(2px * var(--tw-divide-x-reverse));
    border-inline-end-width: calc(2px * calc(1 - var(--tw-divide-x-reverse)));
  }
  :where(.divide-y > :not(:last-child)) {
    --tw-divide-y-reverse: 0;
    border-bottom-style: var(--tw-border-style);
    border-top-style: var(--tw-border-style);
    border-top-width: calc(1px * var(--tw-divide-y-reverse));
    border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  }
  :where(.divide-charcoal-50 > :not(:last-child)) {
    border-color: var(--color-charcoal-50);
  }
  :where(.divide-charcoal-100 > :not(:last-child)) {
    border-color: var(--color-charcoal-100);
  }
  :where(.divide-charcoal-200 > :not(:last-child)) {
    border-color: var(--color-charcoal-200);
  }
  :where(.divide-charcoal-300 > :not(:last-child)) {
    border-color: var(--color-charcoal-300);
  }
  :where(.divide-charcoal-500 > :not(:last-child)) {
    border-color: var(--color-charcoal-500);
  }
  :where(.divide-white > :not(:last-child)) {
    border-color: var(--color-white);
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overflow-y-scroll {
    overflow-y: scroll;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-3xl {
    border-radius: var(--radius-3xl);
  }
  .rounded-\\[56px\\] {
    border-radius: 56px;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-xs {
    border-radius: var(--radius-xs);
  }
  .rounded-t-lg {
    border-top-left-radius: var(--radius-lg);
    border-top-right-radius: var(--radius-lg);
  }
  .rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .rounded-t-xl {
    border-top-left-radius: var(--radius-xl);
    border-top-right-radius: var(--radius-xl);
  }
  .rounded-l-full {
    border-top-left-radius: calc(infinity * 1px);
    border-bottom-left-radius: calc(infinity * 1px);
  }
  .rounded-l-lg {
    border-top-left-radius: var(--radius-lg);
    border-bottom-left-radius: var(--radius-lg);
  }
  .rounded-l-md {
    border-top-left-radius: var(--radius-md);
    border-bottom-left-radius: var(--radius-md);
  }
  .rounded-r-full {
    border-top-right-radius: calc(infinity * 1px);
    border-bottom-right-radius: calc(infinity * 1px);
  }
  .rounded-r-lg {
    border-top-right-radius: var(--radius-lg);
    border-bottom-right-radius: var(--radius-lg);
  }
  .rounded-r-md {
    border-top-right-radius: var(--radius-md);
    border-bottom-right-radius: var(--radius-md);
  }
  .rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }
  .rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .rounded-br-xl {
    border-bottom-right-radius: var(--radius-xl);
  }
  .btn-secondary {
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-blumine-900);
    background-color: var(--color-white);
    color: var(--color-blumine-900);
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blumine-100);
      }
    }
    &:focus {
      background-color: var(--color-blumine-200);
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-blumine-900);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    }
    &:disabled {
      border-color: var(--color-charcoal-300);
    }
    &:disabled {
      color: var(--color-charcoal-300);
    }
  }
  .btn-tertiary {
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: transparent;
    background-color: var(--color-white);
    color: var(--color-blumine-900);
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blumine-100);
      }
    }
    &:focus {
      background-color: var(--color-blumine-200);
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-blumine-900);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    }
    &:disabled {
      color: var(--color-charcoal-300);
    }
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-4 {
    border-style: var(--tw-border-style);
    border-width: 4px;
  }
  .border-50 {
    border-style: var(--tw-border-style);
    border-width: 50px;
  }
  .border-y-2 {
    border-block-style: var(--tw-border-style);
    border-block-width: 2px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-t-2 {
    border-top-style: var(--tw-border-style);
    border-top-width: 2px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-r-0 {
    border-right-style: var(--tw-border-style);
    border-right-width: 0px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-b-\\[50vh\\] {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 50vh;
  }
  .border-l-0 {
    border-left-style: var(--tw-border-style);
    border-left-width: 0px;
  }
  .border-l-2 {
    border-left-style: var(--tw-border-style);
    border-left-width: 2px;
  }
  .border-l-3 {
    border-left-style: var(--tw-border-style);
    border-left-width: 3px;
  }
  .border-l-4 {
    border-left-style: var(--tw-border-style);
    border-left-width: 4px;
  }
  .border-l-\\[80vw\\] {
    border-left-style: var(--tw-border-style);
    border-left-width: 80vw;
  }
  .border-dotted {
    --tw-border-style: dotted;
    border-style: dotted;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-solid {
    --tw-border-style: solid;
    border-style: solid;
  }
  .border-\\[rgb\\(0\\,0\\,255\\)\\] {
    border-color: rgb(0,0,255);
  }
  .border-\\[rgb\\(0\\,160\\,0\\)\\] {
    border-color: rgb(0,160,0);
  }
  .border-\\[rgb\\(0\\,208\\,0\\)\\] {
    border-color: rgb(0,208,0);
  }
  .border-\\[rgb\\(0\\,208\\,104\\)\\] {
    border-color: rgb(0,208,104);
  }
  .border-\\[rgb\\(0\\,224\\,0\\)\\] {
    border-color: rgb(0,224,0);
  }
  .border-\\[rgb\\(0\\,244\\,112\\)\\] {
    border-color: rgb(0,244,112);
  }
  .border-\\[rgb\\(0\\.5\\,0\\.5\\,0\\.5\\)\\] {
    border-color: rgb(0.5,0.5,0.5);
  }
  .border-\\[rgb\\(80\\,255\\,80\\)\\] {
    border-color: rgb(80,255,80);
  }
  .border-\\[rgb\\(112\\,255\\,112\\)\\] {
    border-color: rgb(112,255,112);
  }
  .border-\\[rgb\\(144\\,108\\,0\\)\\] {
    border-color: rgb(144,108,0);
  }
  .border-\\[rgb\\(144\\,240\\,0\\)\\] {
    border-color: rgb(144,240,0);
  }
  .border-\\[rgb\\(160\\,0\\,160\\)\\] {
    border-color: rgb(160,0,160);
  }
  .border-\\[rgb\\(176\\,176\\,176\\)\\] {
    border-color: rgb(176,176,176);
  }
  .border-\\[rgb\\(192\\,48\\,0\\)\\] {
    border-color: rgb(192,48,0);
  }
  .border-\\[rgb\\(192\\,144\\,0\\)\\] {
    border-color: rgb(192,144,0);
  }
  .border-\\[rgb\\(192\\,255\\,96\\)\\] {
    border-color: rgb(192,255,96);
  }
  .border-\\[rgb\\(208\\,156\\,0\\)\\] {
    border-color: rgb(208,156,0);
  }
  .border-\\[rgb\\(224\\,0\\,0\\)\\] {
    border-color: rgb(224,0,0);
  }
  .border-\\[rgb\\(224\\,56\\,0\\)\\] {
    border-color: rgb(224,56,0);
  }
  .border-\\[rgb\\(255\\,0\\,138\\)\\] {
    border-color: rgb(255,0,138);
  }
  .border-\\[rgb\\(255\\,0\\,255\\)\\] {
    border-color: rgb(255,0,255);
  }
  .border-\\[rgb\\(255\\,88\\,32\\)\\] {
    border-color: rgb(255,88,32);
  }
  .border-\\[rgb\\(255\\,96\\,96\\)\\] {
    border-color: rgb(255,96,96);
  }
  .border-\\[rgb\\(255\\,96\\,176\\)\\] {
    border-color: rgb(255,96,176);
  }
  .border-\\[rgb\\(255\\,112\\,255\\)\\] {
    border-color: rgb(255,112,255);
  }
  .border-\\[rgb\\(255\\,128\\,0\\)\\] {
    border-color: rgb(255,128,0);
  }
  .border-\\[rgb\\(255\\,128\\,255\\)\\] {
    border-color: rgb(255,128,255);
  }
  .border-\\[rgb\\(255\\,168\\,80\\)\\] {
    border-color: rgb(255,168,80);
  }
  .border-\\[rgb\\(255\\,176\\,255\\)\\] {
    border-color: rgb(255,176,255);
  }
  .border-\\[rgb\\(255\\,192\\,0\\)\\] {
    border-color: rgb(255,192,0);
  }
  .border-\\[rgb\\(255\\,216\\,96\\)\\] {
    border-color: rgb(255,216,96);
  }
  .border-\\[rgb\\(255\\,244\\,208\\)\\] {
    border-color: rgb(255,244,208);
  }
  .border-\\[rgb\\(255\\,255\\,144\\)\\] {
    border-color: rgb(255,255,144);
  }
  .border-black {
    border-color: var(--color-black);
  }
  .border-blumine-500 {
    border-color: var(--color-blumine-500);
  }
  .border-blumine-700 {
    border-color: var(--color-blumine-700);
  }
  .border-blumine-800 {
    border-color: var(--color-blumine-800);
  }
  .border-blumine-900 {
    border-color: var(--color-blumine-900);
  }
  .border-charcoal-50 {
    border-color: var(--color-charcoal-50);
  }
  .border-charcoal-100 {
    border-color: var(--color-charcoal-100);
  }
  .border-charcoal-200 {
    border-color: var(--color-charcoal-200);
  }
  .border-charcoal-300 {
    border-color: var(--color-charcoal-300);
  }
  .border-charcoal-500 {
    border-color: var(--color-charcoal-500);
  }
  .border-charcoal-900 {
    border-color: var(--color-charcoal-900);
  }
  .border-jade-500 {
    border-color: var(--color-jade-500);
  }
  .border-jade-600 {
    border-color: var(--color-jade-600);
  }
  .border-jade-800 {
    border-color: var(--color-jade-800);
  }
  .border-ochre-500 {
    border-color: var(--color-ochre-500);
  }
  .border-ochre-700 {
    border-color: var(--color-ochre-700);
  }
  .border-phrase-color-100 {
    border-color: var(--color-ochre-100);
  }
  .border-phrase-color-200 {
    border-color: var(--color-ochre-200);
  }
  .border-phrase-color-500 {
    border-color: var(--color-ochre-500);
  }
  .border-phrase-color-600 {
    border-color: var(--color-ochre-600);
  }
  .border-phrase-color-700 {
    border-color: var(--color-ochre-700);
  }
  .border-phrase-color-800 {
    border-color: var(--color-ochre-800);
  }
  .border-phrase-color-900 {
    border-color: var(--color-ochre-900);
  }
  .border-scarlet-800 {
    border-color: var(--color-scarlet-800);
  }
  .border-scarlet-900 {
    border-color: var(--color-scarlet-900);
  }
  .border-song-color-100 {
    border-color: var(--color-scarlet-100);
  }
  .border-song-color-200 {
    border-color: var(--color-scarlet-200);
  }
  .border-song-color-600 {
    border-color: var(--color-scarlet-600);
  }
  .border-song-color-700 {
    border-color: var(--color-scarlet-700);
  }
  .border-song-color-800 {
    border-color: var(--color-scarlet-800);
  }
  .border-song-color-900 {
    border-color: var(--color-scarlet-900);
  }
  .border-story-color-100 {
    border-color: var(--color-blumine-100);
  }
  .border-story-color-200 {
    border-color: var(--color-blumine-200);
  }
  .border-story-color-600 {
    border-color: var(--color-blumine-600);
  }
  .border-story-color-700 {
    border-color: var(--color-blumine-700);
  }
  .border-story-color-800 {
    border-color: var(--color-blumine-800);
  }
  .border-story-color-900 {
    border-color: var(--color-blumine-900);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-white {
    border-color: var(--color-white);
  }
  .border-white\\/10 {
    border-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
  }
  .border-word-color-100 {
    border-color: var(--color-jade-100);
  }
  .border-word-color-200 {
    border-color: var(--color-jade-200);
  }
  .border-word-color-500 {
    border-color: var(--color-jade-500);
  }
  .border-word-color-600 {
    border-color: var(--color-jade-600);
  }
  .border-word-color-700 {
    border-color: var(--color-jade-700);
  }
  .border-word-color-800 {
    border-color: var(--color-jade-800);
  }
  .border-word-color-900 {
    border-color: var(--color-jade-900);
  }
  .border-wordsy-correct {
    border-color: var(--color-jade-500);
  }
  .border-wordsy-present {
    border-color: var(--color-ochre-600);
  }
  .border-y-transparent {
    border-block-color: transparent;
  }
  .border-r-transparent {
    border-right-color: transparent;
  }
  .border-b-scarlet-100 {
    border-bottom-color: var(--color-scarlet-100);
  }
  .border-l-transparent {
    border-left-color: transparent;
  }
  .border-l-white {
    border-left-color: var(--color-white);
  }
  .btn-primary {
    background-color: var(--color-blumine-600);
    color: var(--color-blumine-100);
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blumine-800);
      }
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-blumine-300);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    }
    &:disabled {
      background-color: var(--color-charcoal-300);
    }
    &:disabled {
      color: var(--color-charcoal-50);
    }
  }
  .bg-blumine-50 {
    background-color: var(--color-blumine-50);
  }
  .bg-blumine-100 {
    background-color: var(--color-blumine-100);
  }
  .bg-blumine-400 {
    background-color: var(--color-blumine-400);
  }
  .bg-blumine-600 {
    background-color: var(--color-blumine-600);
  }
  .bg-blumine-700 {
    background-color: var(--color-blumine-700);
  }
  .bg-blumine-800 {
    background-color: var(--color-blumine-800);
  }
  .bg-blumine-900 {
    background-color: var(--color-blumine-900);
  }
  .bg-charcoal-50 {
    background-color: var(--color-charcoal-50);
  }
  .bg-charcoal-100 {
    background-color: var(--color-charcoal-100);
  }
  .bg-charcoal-300 {
    background-color: var(--color-charcoal-300);
  }
  .bg-charcoal-500 {
    background-color: var(--color-charcoal-500);
  }
  .bg-charcoal-700\\/75 {
    background-color: color-mix(in srgb, #4d4d51 75%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-charcoal-700) 75%, transparent);
    }
  }
  .bg-charcoal-900 {
    background-color: var(--color-charcoal-900);
  }
  .bg-inherit {
    background-color: inherit;
  }
  .bg-jade-50 {
    background-color: var(--color-jade-50);
  }
  .bg-jade-400 {
    background-color: var(--color-jade-400);
  }
  .bg-jade-500 {
    background-color: var(--color-jade-500);
  }
  .bg-jade-600 {
    background-color: var(--color-jade-600);
  }
  .bg-ochre-50 {
    background-color: var(--color-ochre-50);
  }
  .bg-ochre-400 {
    background-color: var(--color-ochre-400);
  }
  .bg-ochre-600 {
    background-color: var(--color-ochre-600);
  }
  .bg-phrase-color-100 {
    background-color: var(--color-ochre-100);
  }
  .bg-phrase-color-200 {
    background-color: var(--color-ochre-200);
  }
  .bg-phrase-color-500 {
    background-color: var(--color-ochre-500);
  }
  .bg-phrase-color-600 {
    background-color: var(--color-ochre-600);
  }
  .bg-phrase-color-700 {
    background-color: var(--color-ochre-700);
  }
  .bg-phrase-color-800 {
    background-color: var(--color-ochre-800);
  }
  .bg-phrase-color-900 {
    background-color: var(--color-ochre-900);
  }
  .bg-red-100 {
    background-color: var(--color-red-100);
  }
  .bg-scarlet-50 {
    background-color: var(--color-scarlet-50);
  }
  .bg-scarlet-400 {
    background-color: var(--color-scarlet-400);
  }
  .bg-scarlet-800 {
    background-color: var(--color-scarlet-800);
  }
  .bg-scarlet-900 {
    background-color: var(--color-scarlet-900);
  }
  .bg-song-color-100 {
    background-color: var(--color-scarlet-100);
  }
  .bg-song-color-200 {
    background-color: var(--color-scarlet-200);
  }
  .bg-song-color-600 {
    background-color: var(--color-scarlet-600);
  }
  .bg-song-color-700 {
    background-color: var(--color-scarlet-700);
  }
  .bg-song-color-800 {
    background-color: var(--color-scarlet-800);
  }
  .bg-song-color-900 {
    background-color: var(--color-scarlet-900);
  }
  .bg-story-color-100 {
    background-color: var(--color-blumine-100);
  }
  .bg-story-color-200 {
    background-color: var(--color-blumine-200);
  }
  .bg-story-color-600 {
    background-color: var(--color-blumine-600);
  }
  .bg-story-color-700 {
    background-color: var(--color-blumine-700);
  }
  .bg-story-color-800 {
    background-color: var(--color-blumine-800);
  }
  .bg-story-color-900 {
    background-color: var(--color-blumine-900);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-word-color-100 {
    background-color: var(--color-jade-100);
  }
  .bg-word-color-200 {
    background-color: var(--color-jade-200);
  }
  .bg-word-color-500 {
    background-color: var(--color-jade-500);
  }
  .bg-word-color-600 {
    background-color: var(--color-jade-600);
  }
  .bg-word-color-700 {
    background-color: var(--color-jade-700);
  }
  .bg-word-color-800 {
    background-color: var(--color-jade-800);
  }
  .bg-word-color-900 {
    background-color: var(--color-jade-900);
  }
  .bg-wordsy-correct {
    background-color: var(--color-jade-500);
  }
  .bg-wordsy-present {
    background-color: var(--color-ochre-600);
  }
  .bg-linear-to-b {
    --tw-gradient-position: to bottom;
    @supports (background-image: linear-gradient(in lab, red, red)) {
      --tw-gradient-position: to bottom in oklab;
    }
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-none {
    background-image: none;
  }
  .from-jade-500 {
    --tw-gradient-from: var(--color-jade-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-phrase-color-100 {
    --tw-gradient-from: var(--color-ochre-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-phrase-color-200 {
    --tw-gradient-from: var(--color-ochre-200);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-phrase-color-500 {
    --tw-gradient-from: var(--color-ochre-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-phrase-color-600 {
    --tw-gradient-from: var(--color-ochre-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-phrase-color-700 {
    --tw-gradient-from: var(--color-ochre-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-phrase-color-800 {
    --tw-gradient-from: var(--color-ochre-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-phrase-color-900 {
    --tw-gradient-from: var(--color-ochre-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-white {
    --tw-gradient-from: var(--color-white);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-word-color-100 {
    --tw-gradient-from: var(--color-jade-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-word-color-200 {
    --tw-gradient-from: var(--color-jade-200);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-word-color-500 {
    --tw-gradient-from: var(--color-jade-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-word-color-600 {
    --tw-gradient-from: var(--color-jade-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-word-color-700 {
    --tw-gradient-from: var(--color-jade-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-word-color-800 {
    --tw-gradient-from: var(--color-jade-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-word-color-900 {
    --tw-gradient-from: var(--color-jade-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-charcoal-50 {
    --tw-gradient-to: var(--color-charcoal-50);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-jade-700 {
    --tw-gradient-to: var(--color-jade-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-phrase-color-100 {
    --tw-gradient-to: var(--color-ochre-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-phrase-color-200 {
    --tw-gradient-to: var(--color-ochre-200);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-phrase-color-500 {
    --tw-gradient-to: var(--color-ochre-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-phrase-color-600 {
    --tw-gradient-to: var(--color-ochre-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-phrase-color-700 {
    --tw-gradient-to: var(--color-ochre-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-phrase-color-800 {
    --tw-gradient-to: var(--color-ochre-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-phrase-color-900 {
    --tw-gradient-to: var(--color-ochre-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-word-color-100 {
    --tw-gradient-to: var(--color-jade-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-word-color-200 {
    --tw-gradient-to: var(--color-jade-200);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-word-color-500 {
    --tw-gradient-to: var(--color-jade-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-word-color-600 {
    --tw-gradient-to: var(--color-jade-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-word-color-700 {
    --tw-gradient-to: var(--color-jade-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-word-color-800 {
    --tw-gradient-to: var(--color-jade-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-word-color-900 {
    --tw-gradient-to: var(--color-jade-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .bg-cover {
    background-size: cover;
  }
  .bg-center {
    background-position: center;
  }
  .bg-right {
    background-position: right;
  }
  .bg-no-repeat {
    background-repeat: no-repeat;
  }
  .fill-blumine-500 {
    fill: var(--color-blumine-500);
  }
  .fill-blumine-800 {
    fill: var(--color-blumine-800);
  }
  .fill-charcoal-700 {
    fill: var(--color-charcoal-700);
  }
  .fill-current {
    fill: currentcolor;
  }
  .fill-jade-500 {
    fill: var(--color-jade-500);
  }
  .fill-ochre-400 {
    fill: var(--color-ochre-400);
  }
  .fill-white {
    fill: var(--color-white);
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .object-center {
    object-position: center;
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: var(--spacing);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-3\\.5 {
    padding: calc(var(--spacing) * 3.5);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .p-10 {
    padding: calc(var(--spacing) * 10);
  }
  .p-16 {
    padding: calc(var(--spacing) * 16);
  }
  .p-20 {
    padding: calc(var(--spacing) * 20);
  }
  .px-1 {
    padding-inline: var(--spacing);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-3\\.5 {
    padding-inline: calc(var(--spacing) * 3.5);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .px-10 {
    padding-inline: calc(var(--spacing) * 10);
  }
  .px-14 {
    padding-inline: calc(var(--spacing) * 14);
  }
  .px-16 {
    padding-inline: calc(var(--spacing) * 16);
  }
  .px-20 {
    padding-inline: calc(var(--spacing) * 20);
  }
  .px-24 {
    padding-inline: calc(var(--spacing) * 24);
  }
  .px-28 {
    padding-inline: calc(var(--spacing) * 28);
  }
  .py-1 {
    padding-block: var(--spacing);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-3\\.5 {
    padding-block: calc(var(--spacing) * 3.5);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .py-10 {
    padding-block: calc(var(--spacing) * 10);
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12);
  }
  .py-14 {
    padding-block: calc(var(--spacing) * 14);
  }
  .pt-0 {
    padding-top: 0px;
  }
  .pt-1 {
    padding-top: var(--spacing);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-5 {
    padding-top: calc(var(--spacing) * 5);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pt-10 {
    padding-top: calc(var(--spacing) * 10);
  }
  .pt-16 {
    padding-top: calc(var(--spacing) * 16);
  }
  .pt-32 {
    padding-top: calc(var(--spacing) * 32);
  }
  .pr-0 {
    padding-right: 0px;
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-3 {
    padding-right: calc(var(--spacing) * 3);
  }
  .pr-3\\.5 {
    padding-right: calc(var(--spacing) * 3.5);
  }
  .pr-4 {
    padding-right: calc(var(--spacing) * 4);
  }
  .pr-5 {
    padding-right: calc(var(--spacing) * 5);
  }
  .pr-6 {
    padding-right: calc(var(--spacing) * 6);
  }
  .pr-8 {
    padding-right: calc(var(--spacing) * 8);
  }
  .pr-10 {
    padding-right: calc(var(--spacing) * 10);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-5 {
    padding-bottom: calc(var(--spacing) * 5);
  }
  .pb-6 {
    padding-bottom: calc(var(--spacing) * 6);
  }
  .pb-8 {
    padding-bottom: calc(var(--spacing) * 8);
  }
  .pb-10 {
    padding-bottom: calc(var(--spacing) * 10);
  }
  .pb-16 {
    padding-bottom: calc(var(--spacing) * 16);
  }
  .pb-20 {
    padding-bottom: calc(var(--spacing) * 20);
  }
  .pb-\\[50\\%\\] {
    padding-bottom: 50%;
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .pl-3\\.5 {
    padding-left: calc(var(--spacing) * 3.5);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .pl-5 {
    padding-left: calc(var(--spacing) * 5);
  }
  .pl-6 {
    padding-left: calc(var(--spacing) * 6);
  }
  .pl-9 {
    padding-left: calc(var(--spacing) * 9);
  }
  .pl-10 {
    padding-left: calc(var(--spacing) * 10);
  }
  .pl-14 {
    padding-left: calc(var(--spacing) * 14);
  }
  .pl-16 {
    padding-left: calc(var(--spacing) * 16);
  }
  .pl-64 {
    padding-left: calc(var(--spacing) * 64);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .align-bottom {
    vertical-align: bottom;
  }
  .align-middle {
    vertical-align: middle;
  }
  .align-top {
    vertical-align: top;
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-4xl {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
  }
  .text-5xl {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-base\\/7 {
    font-size: var(--text-base);
    line-height: calc(var(--spacing) * 7);
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-lg\\/8 {
    font-size: var(--text-lg);
    line-height: calc(var(--spacing) * 8);
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .leading-4 {
    --tw-leading: calc(var(--spacing) * 4);
    line-height: calc(var(--spacing) * 4);
  }
  .leading-5 {
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
  }
  .leading-6 {
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
  }
  .leading-7 {
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
  }
  .leading-8 {
    --tw-leading: calc(var(--spacing) * 8);
    line-height: calc(var(--spacing) * 8);
  }
  .leading-10 {
    --tw-leading: calc(var(--spacing) * 10);
    line-height: calc(var(--spacing) * 10);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .font-black {
    --tw-font-weight: var(--font-weight-black);
    font-weight: var(--font-weight-black);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-extrabold {
    --tw-font-weight: var(--font-weight-extrabold);
    font-weight: var(--font-weight-extrabold);
  }
  .font-light {
    --tw-font-weight: var(--font-weight-light);
    font-weight: var(--font-weight-light);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .text-balance {
    text-wrap: balance;
  }
  .text-nowrap {
    text-wrap: nowrap;
  }
  .text-pretty {
    text-wrap: pretty;
  }
  .text-wrap {
    text-wrap: wrap;
  }
  .wrap-anywhere {
    overflow-wrap: anywhere;
  }
  .wrap-break-word {
    overflow-wrap: break-word;
  }
  .whitespace-normal {
    white-space: normal;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .whitespace-pre-line {
    white-space: pre-line;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .inline-url {
    color: var(--color-blue-600);
    text-decoration-line: underline;
    text-underline-offset: 2px;
    &:visited {
      color: var(--color-purple-600);
    }
  }
  .text-black {
    color: var(--color-black);
  }
  .text-blue-300 {
    color: var(--color-blue-300);
  }
  .text-blue-700 {
    color: var(--color-blue-700);
  }
  .text-blue-900 {
    color: var(--color-blue-900);
  }
  .text-blumine-500 {
    color: var(--color-blumine-500);
  }
  .text-blumine-600 {
    color: var(--color-blumine-600);
  }
  .text-blumine-700 {
    color: var(--color-blumine-700);
  }
  .text-blumine-800 {
    color: var(--color-blumine-800);
  }
  .text-blumine-900 {
    color: var(--color-blumine-900);
  }
  .text-charcoal-50 {
    color: var(--color-charcoal-50);
  }
  .text-charcoal-200 {
    color: var(--color-charcoal-200);
  }
  .text-charcoal-300 {
    color: var(--color-charcoal-300);
  }
  .text-charcoal-400 {
    color: var(--color-charcoal-400);
  }
  .text-charcoal-500 {
    color: var(--color-charcoal-500);
  }
  .text-charcoal-600 {
    color: var(--color-charcoal-600);
  }
  .text-charcoal-700 {
    color: var(--color-charcoal-700);
  }
  .text-charcoal-800 {
    color: var(--color-charcoal-800);
  }
  .text-charcoal-900 {
    color: var(--color-charcoal-900);
  }
  .text-jade-500 {
    color: var(--color-jade-500);
  }
  .text-jade-700 {
    color: var(--color-jade-700);
  }
  .text-jade-800 {
    color: var(--color-jade-800);
  }
  .text-ochre-500 {
    color: var(--color-ochre-500);
  }
  .text-ochre-600 {
    color: var(--color-ochre-600);
  }
  .text-ochre-800 {
    color: var(--color-ochre-800);
  }
  .text-phrase-color-100 {
    color: var(--color-ochre-100);
  }
  .text-phrase-color-200 {
    color: var(--color-ochre-200);
  }
  .text-phrase-color-500 {
    color: var(--color-ochre-500);
  }
  .text-phrase-color-600 {
    color: var(--color-ochre-600);
  }
  .text-phrase-color-700 {
    color: var(--color-ochre-700);
  }
  .text-phrase-color-800 {
    color: var(--color-ochre-800);
  }
  .text-phrase-color-900 {
    color: var(--color-ochre-900);
  }
  .text-red-700 {
    color: var(--color-red-700);
  }
  .text-scarlet-50 {
    color: var(--color-scarlet-50);
  }
  .text-scarlet-700 {
    color: var(--color-scarlet-700);
  }
  .text-scarlet-800 {
    color: var(--color-scarlet-800);
  }
  .text-scarlet-900 {
    color: var(--color-scarlet-900);
  }
  .text-song-color-100 {
    color: var(--color-scarlet-100);
  }
  .text-song-color-200 {
    color: var(--color-scarlet-200);
  }
  .text-song-color-600 {
    color: var(--color-scarlet-600);
  }
  .text-song-color-700 {
    color: var(--color-scarlet-700);
  }
  .text-song-color-800 {
    color: var(--color-scarlet-800);
  }
  .text-song-color-900 {
    color: var(--color-scarlet-900);
  }
  .text-story-color-100 {
    color: var(--color-blumine-100);
  }
  .text-story-color-200 {
    color: var(--color-blumine-200);
  }
  .text-story-color-600 {
    color: var(--color-blumine-600);
  }
  .text-story-color-700 {
    color: var(--color-blumine-700);
  }
  .text-story-color-800 {
    color: var(--color-blumine-800);
  }
  .text-story-color-900 {
    color: var(--color-blumine-900);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-white\\/80 {
    color: color-mix(in srgb, #fff 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 80%, transparent);
    }
  }
  .text-word-color-100 {
    color: var(--color-jade-100);
  }
  .text-word-color-200 {
    color: var(--color-jade-200);
  }
  .text-word-color-500 {
    color: var(--color-jade-500);
  }
  .text-word-color-600 {
    color: var(--color-jade-600);
  }
  .text-word-color-700 {
    color: var(--color-jade-700);
  }
  .text-word-color-800 {
    color: var(--color-jade-800);
  }
  .text-word-color-900 {
    color: var(--color-jade-900);
  }
  .text-wordsy-present {
    color: var(--color-ochre-600);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .normal-case {
    text-transform: none;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .underline {
    text-decoration-line: underline;
  }
  .placeholder-charcoal-500::placeholder {
    color: var(--color-charcoal-500);
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-25 {
    opacity: 25%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-75 {
    opacity: 75%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xs {
    --tw-shadow: 0 1px var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xs {
    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-1 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-4 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-black {
    --tw-ring-color: var(--color-black);
  }
  .ring-black\\/50 {
    --tw-ring-color: color-mix(in srgb, #000 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .ring-blumine-500 {
    --tw-ring-color: var(--color-blumine-500);
  }
  .ring-blumine-600 {
    --tw-ring-color: var(--color-blumine-600);
  }
  .ring-charcoal-100 {
    --tw-ring-color: var(--color-charcoal-100);
  }
  .ring-charcoal-200 {
    --tw-ring-color: var(--color-charcoal-200);
  }
  .ring-charcoal-300 {
    --tw-ring-color: var(--color-charcoal-300);
  }
  .ring-charcoal-800 {
    --tw-ring-color: var(--color-charcoal-800);
  }
  .ring-jade-500 {
    --tw-ring-color: var(--color-jade-500);
  }
  .ring-phrase-color-100 {
    --tw-ring-color: var(--color-ochre-100);
  }
  .ring-phrase-color-200 {
    --tw-ring-color: var(--color-ochre-200);
  }
  .ring-phrase-color-500 {
    --tw-ring-color: var(--color-ochre-500);
  }
  .ring-phrase-color-600 {
    --tw-ring-color: var(--color-ochre-600);
  }
  .ring-phrase-color-700 {
    --tw-ring-color: var(--color-ochre-700);
  }
  .ring-phrase-color-800 {
    --tw-ring-color: var(--color-ochre-800);
  }
  .ring-phrase-color-900 {
    --tw-ring-color: var(--color-ochre-900);
  }
  .ring-song-color-100 {
    --tw-ring-color: var(--color-scarlet-100);
  }
  .ring-song-color-200 {
    --tw-ring-color: var(--color-scarlet-200);
  }
  .ring-song-color-600 {
    --tw-ring-color: var(--color-scarlet-600);
  }
  .ring-song-color-700 {
    --tw-ring-color: var(--color-scarlet-700);
  }
  .ring-song-color-800 {
    --tw-ring-color: var(--color-scarlet-800);
  }
  .ring-song-color-900 {
    --tw-ring-color: var(--color-scarlet-900);
  }
  .ring-story-color-100 {
    --tw-ring-color: var(--color-blumine-100);
  }
  .ring-story-color-200 {
    --tw-ring-color: var(--color-blumine-200);
  }
  .ring-story-color-600 {
    --tw-ring-color: var(--color-blumine-600);
  }
  .ring-story-color-700 {
    --tw-ring-color: var(--color-blumine-700);
  }
  .ring-story-color-800 {
    --tw-ring-color: var(--color-blumine-800);
  }
  .ring-story-color-900 {
    --tw-ring-color: var(--color-blumine-900);
  }
  .ring-white {
    --tw-ring-color: var(--color-white);
  }
  .ring-word-color-100 {
    --tw-ring-color: var(--color-jade-100);
  }
  .ring-word-color-200 {
    --tw-ring-color: var(--color-jade-200);
  }
  .ring-word-color-500 {
    --tw-ring-color: var(--color-jade-500);
  }
  .ring-word-color-600 {
    --tw-ring-color: var(--color-jade-600);
  }
  .ring-word-color-700 {
    --tw-ring-color: var(--color-jade-700);
  }
  .ring-word-color-800 {
    --tw-ring-color: var(--color-jade-800);
  }
  .ring-word-color-900 {
    --tw-ring-color: var(--color-jade-900);
  }
  .ring-offset-2 {
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
  .outline-hidden {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .outline-1 {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .-outline-offset-1 {
    outline-offset: calc(1px * -1);
  }
  .outline-black\\/5 {
    outline-color: color-mix(in srgb, #000 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      outline-color: color-mix(in oklab, var(--color-black) 5%, transparent);
    }
  }
  .outline-charcoal-300 {
    outline-color: var(--color-charcoal-300);
  }
  .drop-shadow-md {
    --tw-drop-shadow-size: drop-shadow(0 3px 3px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.12)));
    --tw-drop-shadow: drop-shadow(var(--drop-shadow-md));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-brightness-65 {
    --tw-backdrop-brightness: brightness(65%);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-brightness-90 {
    --tw-backdrop-brightness: brightness(90%);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-75 {
    --tw-duration: 75ms;
    transition-duration: 75ms;
  }
  .duration-100 {
    --tw-duration: 100ms;
    transition-duration: 100ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-500 {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .ease-in {
    --tw-ease: var(--ease-in);
    transition-timing-function: var(--ease-in);
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .outline-solid {
    --tw-outline-style: solid;
    outline-style: solid;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .breakAfter {
    page-break-after: always;
  }
  .point-down {
    clip-path: polygon(50% 100%, 0% 0%, 100% 0%);
  }
  @media (hover: hover) {
    .group-hover\\:flex:is(:where(.group):hover *) {
      display: flex;
    }
    .group-hover\\:hidden:is(:where(.group):hover *) {
      display: none;
    }
    .group-hover\\:scale-100:is(:where(.group):hover *) {
      --tw-scale-x: 100%;
      --tw-scale-y: 100%;
      --tw-scale-z: 100%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
    .group-hover\\:border-charcoal-500:is(:where(.group):hover *) {
      border-color: var(--color-charcoal-500);
    }
    .group-hover\\:bg-blumine-900:is(:where(.group):hover *) {
      background-color: var(--color-blumine-900);
    }
    .group-hover\\:fill-white:is(:where(.group):hover *) {
      fill: var(--color-white);
    }
    .group-hover\\:text-charcoal-100:is(:where(.group):hover *) {
      color: var(--color-charcoal-100);
    }
    .group-hover\\:text-charcoal-200:is(:where(.group):hover *) {
      color: var(--color-charcoal-200);
    }
    .group-hover\\:text-charcoal-500:is(:where(.group):hover *) {
      color: var(--color-charcoal-500);
    }
    .group-hover\\:text-charcoal-900:is(:where(.group):hover *) {
      color: var(--color-charcoal-900);
    }
    .group-hover\\:opacity-75:is(:where(.group):hover *) {
      opacity: 75%;
    }
    .group-hover\\:opacity-100:is(:where(.group):hover *) {
      opacity: 100%;
    }
  }
  .group-focus\\:text-charcoal-900:is(:where(.group):focus *) {
    color: var(--color-charcoal-900);
  }
  .group-data-selected\\:visible:is(:where(.group)[data-selected] *) {
    visibility: visible;
  }
  .group-data-selected\\:font-bold:is(:where(.group)[data-selected] *) {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .group-data-selected\\:text-blumine-600:is(:where(.group)[data-selected] *) {
    color: var(--color-blumine-600);
  }
  .file\\:mr-5::file-selector-button {
    margin-right: calc(var(--spacing) * 5);
  }
  .file\\:btn-md::file-selector-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
    border-radius: var(--radius-lg);
    &:disabled {
      pointer-events: none;
    }
    height: calc(var(--spacing) * 11);
    min-width: calc(var(--spacing) * 32);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    @media (width >= 80rem) {
      height: calc(var(--spacing) * 10);
    }
    @media (width >= 80rem) {
      min-width: calc(var(--spacing) * 40);
    }
    @media (width >= 80rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    & svg {
      height: calc(var(--spacing) * 5);
      width: calc(var(--spacing) * 5);
      fill: currentcolor;
    }
  }
  .file\\:btn-secondary::file-selector-button {
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-blumine-900);
    background-color: var(--color-white);
    color: var(--color-blumine-900);
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blumine-100);
      }
    }
    &:focus {
      background-color: var(--color-blumine-200);
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-blumine-900);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    }
    &:disabled {
      border-color: var(--color-charcoal-300);
    }
    &:disabled {
      color: var(--color-charcoal-300);
    }
  }
  .placeholder\\:text-charcoal-400::placeholder {
    color: var(--color-charcoal-400);
  }
  .placeholder\\:text-charcoal-500::placeholder {
    color: var(--color-charcoal-500);
  }
  .placeholder\\:italic::placeholder {
    font-style: italic;
  }
  .last\\:border-b-0:last-child {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
  .focus-within\\:text-charcoal-700:focus-within {
    color: var(--color-charcoal-700);
  }
  .focus-within\\:ring-2:focus-within {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus-within\\:ring-blumine-600:focus-within {
    --tw-ring-color: var(--color-blumine-600);
  }
  .focus-within\\:ring-blumine-800:focus-within {
    --tw-ring-color: var(--color-blumine-800);
  }
  .focus-within\\:ring-ochre-800:focus-within {
    --tw-ring-color: var(--color-ochre-800);
  }
  .focus-within\\:ring-scarlet-800:focus-within {
    --tw-ring-color: var(--color-scarlet-800);
  }
  .focus-within\\:ring-offset-1:focus-within {
    --tw-ring-offset-width: 1px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
  .focus-within\\:ring-offset-2:focus-within {
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
  .focus-within\\:ring-offset-blumine-100:focus-within {
    --tw-ring-offset-color: var(--color-blumine-100);
  }
  .focus-within\\:ring-offset-charcoal-50:focus-within {
    --tw-ring-offset-color: var(--color-charcoal-50);
  }
  .focus-within\\:ring-inset:focus-within {
    --tw-ring-inset: inset;
  }
  @media (hover: hover) {
    .hover\\:cursor-pointer:hover {
      cursor: pointer;
    }
    .hover\\:border-charcoal-400:hover {
      border-color: var(--color-charcoal-400);
    }
    .hover\\:border-charcoal-900:hover {
      border-color: var(--color-charcoal-900);
    }
    .hover\\:border-jade-500:hover {
      border-color: var(--color-jade-500);
    }
    .hover\\:border-ochre-600:hover {
      border-color: var(--color-ochre-600);
    }
    .hover\\:bg-blumine-50:hover {
      background-color: var(--color-blumine-50);
    }
    .hover\\:bg-blumine-100:hover {
      background-color: var(--color-blumine-100);
    }
    .hover\\:bg-blumine-300:hover {
      background-color: var(--color-blumine-300);
    }
    .hover\\:bg-charcoal-50:hover {
      background-color: var(--color-charcoal-50);
    }
    .hover\\:bg-charcoal-100:hover {
      background-color: var(--color-charcoal-100);
    }
    .hover\\:bg-charcoal-200:hover {
      background-color: var(--color-charcoal-200);
    }
    .hover\\:bg-charcoal-500:hover {
      background-color: var(--color-charcoal-500);
    }
    .hover\\:bg-jade-500:hover {
      background-color: var(--color-jade-500);
    }
    .hover\\:bg-ochre-600:hover {
      background-color: var(--color-ochre-600);
    }
    .hover\\:bg-ochre-700:hover {
      background-color: var(--color-ochre-700);
    }
    .hover\\:bg-ochre-800:hover {
      background-color: var(--color-ochre-800);
    }
    .hover\\:bg-scarlet-50:hover {
      background-color: var(--color-scarlet-50);
    }
    .hover\\:bg-scarlet-100:hover {
      background-color: var(--color-scarlet-100);
    }
    .hover\\:bg-scarlet-900:hover {
      background-color: var(--color-scarlet-900);
    }
    .hover\\:bg-white:hover {
      background-color: var(--color-white);
    }
    .hover\\:text-blumine-600:hover {
      color: var(--color-blumine-600);
    }
    .hover\\:text-blumine-800:hover {
      color: var(--color-blumine-800);
    }
    .hover\\:text-charcoal-50:hover {
      color: var(--color-charcoal-50);
    }
    .hover\\:text-charcoal-200:hover {
      color: var(--color-charcoal-200);
    }
    .hover\\:text-charcoal-700:hover {
      color: var(--color-charcoal-700);
    }
    .hover\\:text-charcoal-900:hover {
      color: var(--color-charcoal-900);
    }
    .hover\\:text-scarlet-800:hover {
      color: var(--color-scarlet-800);
    }
    .hover\\:text-white:hover {
      color: var(--color-white);
    }
    .hover\\:opacity-75:hover {
      opacity: 75%;
    }
    .hover\\:opacity-80:hover {
      opacity: 80%;
    }
    .hover\\:shadow-xs:hover {
      --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    .hover\\:backdrop-brightness-75:hover {
      --tw-backdrop-brightness: brightness(75%);
      -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
      backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    }
    .hover\\:file\\:cursor-pointer:hover::file-selector-button {
      cursor: pointer;
    }
    .hover\\:file\\:bg-blumine-100:hover::file-selector-button {
      background-color: var(--color-blumine-100);
    }
  }
  .focus\\:border-blumine-600:focus {
    border-color: var(--color-blumine-600);
  }
  .focus\\:border-blumine-700:focus {
    border-color: var(--color-blumine-700);
  }
  .focus\\:border-blumine-800:focus {
    border-color: var(--color-blumine-800);
  }
  .focus\\:border-charcoal-500:focus {
    border-color: var(--color-charcoal-500);
  }
  .focus\\:border-phrase-color-100:focus {
    border-color: var(--color-ochre-100);
  }
  .focus\\:border-phrase-color-200:focus {
    border-color: var(--color-ochre-200);
  }
  .focus\\:border-phrase-color-500:focus {
    border-color: var(--color-ochre-500);
  }
  .focus\\:border-phrase-color-600:focus {
    border-color: var(--color-ochre-600);
  }
  .focus\\:border-phrase-color-700:focus {
    border-color: var(--color-ochre-700);
  }
  .focus\\:border-phrase-color-800:focus {
    border-color: var(--color-ochre-800);
  }
  .focus\\:border-phrase-color-900:focus {
    border-color: var(--color-ochre-900);
  }
  .focus\\:border-scarlet-800:focus {
    border-color: var(--color-scarlet-800);
  }
  .focus\\:border-song-color-100:focus {
    border-color: var(--color-scarlet-100);
  }
  .focus\\:border-song-color-200:focus {
    border-color: var(--color-scarlet-200);
  }
  .focus\\:border-song-color-600:focus {
    border-color: var(--color-scarlet-600);
  }
  .focus\\:border-song-color-700:focus {
    border-color: var(--color-scarlet-700);
  }
  .focus\\:border-song-color-800:focus {
    border-color: var(--color-scarlet-800);
  }
  .focus\\:border-song-color-900:focus {
    border-color: var(--color-scarlet-900);
  }
  .focus\\:border-story-color-100:focus {
    border-color: var(--color-blumine-100);
  }
  .focus\\:border-story-color-200:focus {
    border-color: var(--color-blumine-200);
  }
  .focus\\:border-story-color-600:focus {
    border-color: var(--color-blumine-600);
  }
  .focus\\:border-story-color-700:focus {
    border-color: var(--color-blumine-700);
  }
  .focus\\:border-story-color-800:focus {
    border-color: var(--color-blumine-800);
  }
  .focus\\:border-story-color-900:focus {
    border-color: var(--color-blumine-900);
  }
  .focus\\:border-word-color-100:focus {
    border-color: var(--color-jade-100);
  }
  .focus\\:border-word-color-200:focus {
    border-color: var(--color-jade-200);
  }
  .focus\\:border-word-color-500:focus {
    border-color: var(--color-jade-500);
  }
  .focus\\:border-word-color-600:focus {
    border-color: var(--color-jade-600);
  }
  .focus\\:border-word-color-700:focus {
    border-color: var(--color-jade-700);
  }
  .focus\\:border-word-color-800:focus {
    border-color: var(--color-jade-800);
  }
  .focus\\:border-word-color-900:focus {
    border-color: var(--color-jade-900);
  }
  .focus\\:bg-blumine-200:focus {
    background-color: var(--color-blumine-200);
  }
  .focus\\:bg-phrase-color-100:focus {
    background-color: var(--color-ochre-100);
  }
  .focus\\:bg-phrase-color-200:focus {
    background-color: var(--color-ochre-200);
  }
  .focus\\:bg-phrase-color-500:focus {
    background-color: var(--color-ochre-500);
  }
  .focus\\:bg-phrase-color-600:focus {
    background-color: var(--color-ochre-600);
  }
  .focus\\:bg-phrase-color-700:focus {
    background-color: var(--color-ochre-700);
  }
  .focus\\:bg-phrase-color-800:focus {
    background-color: var(--color-ochre-800);
  }
  .focus\\:bg-phrase-color-900:focus {
    background-color: var(--color-ochre-900);
  }
  .focus\\:bg-scarlet-200:focus {
    background-color: var(--color-scarlet-200);
  }
  .focus\\:bg-song-color-100:focus {
    background-color: var(--color-scarlet-100);
  }
  .focus\\:bg-song-color-200:focus {
    background-color: var(--color-scarlet-200);
  }
  .focus\\:bg-song-color-600:focus {
    background-color: var(--color-scarlet-600);
  }
  .focus\\:bg-song-color-700:focus {
    background-color: var(--color-scarlet-700);
  }
  .focus\\:bg-song-color-800:focus {
    background-color: var(--color-scarlet-800);
  }
  .focus\\:bg-song-color-900:focus {
    background-color: var(--color-scarlet-900);
  }
  .focus\\:bg-story-color-100:focus {
    background-color: var(--color-blumine-100);
  }
  .focus\\:bg-story-color-200:focus {
    background-color: var(--color-blumine-200);
  }
  .focus\\:bg-story-color-600:focus {
    background-color: var(--color-blumine-600);
  }
  .focus\\:bg-story-color-700:focus {
    background-color: var(--color-blumine-700);
  }
  .focus\\:bg-story-color-800:focus {
    background-color: var(--color-blumine-800);
  }
  .focus\\:bg-story-color-900:focus {
    background-color: var(--color-blumine-900);
  }
  .focus\\:bg-white:focus {
    background-color: var(--color-white);
  }
  .focus\\:bg-word-color-100:focus {
    background-color: var(--color-jade-100);
  }
  .focus\\:bg-word-color-200:focus {
    background-color: var(--color-jade-200);
  }
  .focus\\:bg-word-color-500:focus {
    background-color: var(--color-jade-500);
  }
  .focus\\:bg-word-color-600:focus {
    background-color: var(--color-jade-600);
  }
  .focus\\:bg-word-color-700:focus {
    background-color: var(--color-jade-700);
  }
  .focus\\:bg-word-color-800:focus {
    background-color: var(--color-jade-800);
  }
  .focus\\:bg-word-color-900:focus {
    background-color: var(--color-jade-900);
  }
  .focus\\:from-phrase-color-100:focus {
    --tw-gradient-from: var(--color-ochre-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-phrase-color-200:focus {
    --tw-gradient-from: var(--color-ochre-200);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-phrase-color-500:focus {
    --tw-gradient-from: var(--color-ochre-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-phrase-color-600:focus {
    --tw-gradient-from: var(--color-ochre-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-phrase-color-700:focus {
    --tw-gradient-from: var(--color-ochre-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-phrase-color-800:focus {
    --tw-gradient-from: var(--color-ochre-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-phrase-color-900:focus {
    --tw-gradient-from: var(--color-ochre-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-word-color-100:focus {
    --tw-gradient-from: var(--color-jade-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-word-color-200:focus {
    --tw-gradient-from: var(--color-jade-200);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-word-color-500:focus {
    --tw-gradient-from: var(--color-jade-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-word-color-600:focus {
    --tw-gradient-from: var(--color-jade-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-word-color-700:focus {
    --tw-gradient-from: var(--color-jade-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-word-color-800:focus {
    --tw-gradient-from: var(--color-jade-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:from-word-color-900:focus {
    --tw-gradient-from: var(--color-jade-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-phrase-color-100:focus {
    --tw-gradient-to: var(--color-ochre-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-phrase-color-200:focus {
    --tw-gradient-to: var(--color-ochre-200);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-phrase-color-500:focus {
    --tw-gradient-to: var(--color-ochre-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-phrase-color-600:focus {
    --tw-gradient-to: var(--color-ochre-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-phrase-color-700:focus {
    --tw-gradient-to: var(--color-ochre-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-phrase-color-800:focus {
    --tw-gradient-to: var(--color-ochre-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-phrase-color-900:focus {
    --tw-gradient-to: var(--color-ochre-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-word-color-100:focus {
    --tw-gradient-to: var(--color-jade-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-word-color-200:focus {
    --tw-gradient-to: var(--color-jade-200);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-word-color-500:focus {
    --tw-gradient-to: var(--color-jade-500);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-word-color-600:focus {
    --tw-gradient-to: var(--color-jade-600);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-word-color-700:focus {
    --tw-gradient-to: var(--color-jade-700);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-word-color-800:focus {
    --tw-gradient-to: var(--color-jade-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:to-word-color-900:focus {
    --tw-gradient-to: var(--color-jade-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .focus\\:text-phrase-color-100:focus {
    color: var(--color-ochre-100);
  }
  .focus\\:text-phrase-color-200:focus {
    color: var(--color-ochre-200);
  }
  .focus\\:text-phrase-color-500:focus {
    color: var(--color-ochre-500);
  }
  .focus\\:text-phrase-color-600:focus {
    color: var(--color-ochre-600);
  }
  .focus\\:text-phrase-color-700:focus {
    color: var(--color-ochre-700);
  }
  .focus\\:text-phrase-color-800:focus {
    color: var(--color-ochre-800);
  }
  .focus\\:text-phrase-color-900:focus {
    color: var(--color-ochre-900);
  }
  .focus\\:text-song-color-100:focus {
    color: var(--color-scarlet-100);
  }
  .focus\\:text-song-color-200:focus {
    color: var(--color-scarlet-200);
  }
  .focus\\:text-song-color-600:focus {
    color: var(--color-scarlet-600);
  }
  .focus\\:text-song-color-700:focus {
    color: var(--color-scarlet-700);
  }
  .focus\\:text-song-color-800:focus {
    color: var(--color-scarlet-800);
  }
  .focus\\:text-song-color-900:focus {
    color: var(--color-scarlet-900);
  }
  .focus\\:text-story-color-100:focus {
    color: var(--color-blumine-100);
  }
  .focus\\:text-story-color-200:focus {
    color: var(--color-blumine-200);
  }
  .focus\\:text-story-color-600:focus {
    color: var(--color-blumine-600);
  }
  .focus\\:text-story-color-700:focus {
    color: var(--color-blumine-700);
  }
  .focus\\:text-story-color-800:focus {
    color: var(--color-blumine-800);
  }
  .focus\\:text-story-color-900:focus {
    color: var(--color-blumine-900);
  }
  .focus\\:text-word-color-100:focus {
    color: var(--color-jade-100);
  }
  .focus\\:text-word-color-200:focus {
    color: var(--color-jade-200);
  }
  .focus\\:text-word-color-500:focus {
    color: var(--color-jade-500);
  }
  .focus\\:text-word-color-600:focus {
    color: var(--color-jade-600);
  }
  .focus\\:text-word-color-700:focus {
    color: var(--color-jade-700);
  }
  .focus\\:text-word-color-800:focus {
    color: var(--color-jade-800);
  }
  .focus\\:text-word-color-900:focus {
    color: var(--color-jade-900);
  }
  .focus\\:ring-2:focus {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus\\:ring-blumine-600:focus {
    --tw-ring-color: var(--color-blumine-600);
  }
  .focus\\:ring-blumine-700:focus {
    --tw-ring-color: var(--color-blumine-700);
  }
  .focus\\:ring-blumine-800:focus {
    --tw-ring-color: var(--color-blumine-800);
  }
  .focus\\:ring-blumine-900:focus {
    --tw-ring-color: var(--color-blumine-900);
  }
  .focus\\:ring-charcoal-300:focus {
    --tw-ring-color: var(--color-charcoal-300);
  }
  .focus\\:ring-charcoal-500:focus {
    --tw-ring-color: var(--color-charcoal-500);
  }
  .focus\\:ring-phrase-color-100:focus {
    --tw-ring-color: var(--color-ochre-100);
  }
  .focus\\:ring-phrase-color-200:focus {
    --tw-ring-color: var(--color-ochre-200);
  }
  .focus\\:ring-phrase-color-500:focus {
    --tw-ring-color: var(--color-ochre-500);
  }
  .focus\\:ring-phrase-color-600:focus {
    --tw-ring-color: var(--color-ochre-600);
  }
  .focus\\:ring-phrase-color-700:focus {
    --tw-ring-color: var(--color-ochre-700);
  }
  .focus\\:ring-phrase-color-800:focus {
    --tw-ring-color: var(--color-ochre-800);
  }
  .focus\\:ring-phrase-color-900:focus {
    --tw-ring-color: var(--color-ochre-900);
  }
  .focus\\:ring-scarlet-500:focus {
    --tw-ring-color: var(--color-scarlet-500);
  }
  .focus\\:ring-scarlet-800:focus {
    --tw-ring-color: var(--color-scarlet-800);
  }
  .focus\\:ring-song-color-100:focus {
    --tw-ring-color: var(--color-scarlet-100);
  }
  .focus\\:ring-song-color-200:focus {
    --tw-ring-color: var(--color-scarlet-200);
  }
  .focus\\:ring-song-color-600:focus {
    --tw-ring-color: var(--color-scarlet-600);
  }
  .focus\\:ring-song-color-700:focus {
    --tw-ring-color: var(--color-scarlet-700);
  }
  .focus\\:ring-song-color-800:focus {
    --tw-ring-color: var(--color-scarlet-800);
  }
  .focus\\:ring-song-color-900:focus {
    --tw-ring-color: var(--color-scarlet-900);
  }
  .focus\\:ring-story-color-100:focus {
    --tw-ring-color: var(--color-blumine-100);
  }
  .focus\\:ring-story-color-200:focus {
    --tw-ring-color: var(--color-blumine-200);
  }
  .focus\\:ring-story-color-600:focus {
    --tw-ring-color: var(--color-blumine-600);
  }
  .focus\\:ring-story-color-700:focus {
    --tw-ring-color: var(--color-blumine-700);
  }
  .focus\\:ring-story-color-800:focus {
    --tw-ring-color: var(--color-blumine-800);
  }
  .focus\\:ring-story-color-900:focus {
    --tw-ring-color: var(--color-blumine-900);
  }
  .focus\\:ring-word-color-100:focus {
    --tw-ring-color: var(--color-jade-100);
  }
  .focus\\:ring-word-color-200:focus {
    --tw-ring-color: var(--color-jade-200);
  }
  .focus\\:ring-word-color-500:focus {
    --tw-ring-color: var(--color-jade-500);
  }
  .focus\\:ring-word-color-600:focus {
    --tw-ring-color: var(--color-jade-600);
  }
  .focus\\:ring-word-color-700:focus {
    --tw-ring-color: var(--color-jade-700);
  }
  .focus\\:ring-word-color-800:focus {
    --tw-ring-color: var(--color-jade-800);
  }
  .focus\\:ring-word-color-900:focus {
    --tw-ring-color: var(--color-jade-900);
  }
  .focus\\:ring-offset-2:focus {
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
  .focus\\:outline-hidden:focus {
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  .focus\\:ring-inset:focus {
    --tw-ring-inset: inset;
  }
  .focus\\:not-data-focus\\:outline-none:focus:not([data-focus]) {
    --tw-outline-style: none;
    outline-style: none;
  }
  .focus-visible\\:ring-2:focus-visible {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus-visible\\:ring-white\\/75:focus-visible {
    --tw-ring-color: color-mix(in srgb, #fff 75%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-white) 75%, transparent);
    }
  }
  .active\\:bg-charcoal-300:active {
    background-color: var(--color-charcoal-300);
  }
  .active\\:text-blumine-900:active {
    color: var(--color-blumine-900);
  }
  .active\\:opacity-100:active {
    opacity: 100%;
  }
  .disabled\\:opacity-0:disabled {
    opacity: 0%;
  }
  .disabled\\:file\\:bg-charcoal-300:disabled::file-selector-button {
    background-color: var(--color-charcoal-300);
  }
  .disabled\\:file\\:text-charcoal-50:disabled::file-selector-button {
    color: var(--color-charcoal-50);
  }
  .data-closed\\:translate-x-full[data-closed] {
    --tw-translate-x: 100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-closed\\:-translate-y-1[data-closed] {
    --tw-translate-y: calc(var(--spacing) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-closed\\:translate-y-4[data-closed] {
    --tw-translate-y: calc(var(--spacing) * 4);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .data-closed\\:scale-95[data-closed] {
    --tw-scale-x: 95%;
    --tw-scale-y: 95%;
    --tw-scale-z: 95%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .data-closed\\:opacity-0[data-closed] {
    opacity: 0%;
  }
  .data-enter\\:duration-200[data-enter] {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .data-enter\\:duration-300[data-enter] {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .data-enter\\:ease-out[data-enter] {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .data-focus\\:bg-blumine-100[data-focus] {
    background-color: var(--color-blumine-100);
  }
  .data-focus\\:bg-charcoal-100[data-focus] {
    background-color: var(--color-charcoal-100);
  }
  .data-focus\\:font-bold[data-focus] {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .data-focus\\:outline[data-focus] {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .data-focus\\:outline-blumine-600[data-focus] {
    outline-color: var(--color-blumine-600);
  }
  .data-leave\\:duration-150[data-leave] {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .data-leave\\:duration-200[data-leave] {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .data-leave\\:ease-in[data-leave] {
    --tw-ease: var(--ease-in);
    transition-timing-function: var(--ease-in);
  }
  .data-leave\\:data-closed\\:opacity-0[data-leave][data-closed] {
    opacity: 0%;
  }
  .data-selected\\:border-4[data-selected] {
    border-style: var(--tw-border-style);
    border-width: 4px;
  }
  .data-selected\\:border-blumine-500[data-selected] {
    border-color: var(--color-blumine-500);
  }
  @media (width >= 40rem) {
    .sm\\:-right-7 {
      right: calc(var(--spacing) * -7);
    }
    .sm\\:col-span-2 {
      grid-column: span 2 / span 2;
    }
    .sm\\:col-span-4 {
      grid-column: span 4 / span 4;
    }
    .sm\\:col-span-6 {
      grid-column: span 6 / span 6;
    }
    .sm\\:col-start-2 {
      grid-column-start: 2;
    }
    .sm\\:col-start-5 {
      grid-column-start: 5;
    }
    .sm\\:mx-8 {
      margin-inline: calc(var(--spacing) * 8);
    }
    .sm\\:mx-auto {
      margin-inline: auto;
    }
    .sm\\:mt-0 {
      margin-top: 0px;
    }
    .sm\\:mt-6 {
      margin-top: calc(var(--spacing) * 6);
    }
    .sm\\:mt-14 {
      margin-top: calc(var(--spacing) * 14);
    }
    .sm\\:mb-3 {
      margin-bottom: calc(var(--spacing) * 3);
    }
    .sm\\:mb-5 {
      margin-bottom: calc(var(--spacing) * 5);
    }
    .sm\\:mb-7 {
      margin-bottom: calc(var(--spacing) * 7);
    }
    .sm\\:mb-11 {
      margin-bottom: calc(var(--spacing) * 11);
    }
    .sm\\:ml-6 {
      margin-left: calc(var(--spacing) * 6);
    }
    .sm\\:btn-md {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    :where(.sm\\:btn-md > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
    .sm\\:btn-md {
      border-radius: var(--radius-lg);
    }
    .sm\\:btn-md:disabled {
      pointer-events: none;
    }
    .sm\\:btn-md {
      height: calc(var(--spacing) * 11);
      min-width: calc(var(--spacing) * 32);
      padding-inline: calc(var(--spacing) * 3);
      padding-block: calc(var(--spacing) * 2);
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    @media (width >= 80rem) {
      .sm\\:btn-md {
        height: calc(var(--spacing) * 10);
        min-width: calc(var(--spacing) * 40);
        font-size: var(--text-base);
        line-height: var(--tw-leading, var(--text-base--line-height));
      }
    }
    .sm\\:btn-md svg {
      height: calc(var(--spacing) * 5);
      width: calc(var(--spacing) * 5);
      fill: currentcolor;
    }
    .sm\\:block {
      display: block;
    }
    .sm\\:flex {
      display: flex;
    }
    .sm\\:hidden {
      display: none;
    }
    .sm\\:size-52 {
      width: calc(var(--spacing) * 52);
      height: calc(var(--spacing) * 52);
    }
    .sm\\:h-10 {
      height: calc(var(--spacing) * 10);
    }
    .sm\\:h-14 {
      height: calc(var(--spacing) * 14);
    }
    .sm\\:h-72 {
      height: calc(var(--spacing) * 72);
    }
    .sm\\:w-16 {
      width: calc(var(--spacing) * 16);
    }
    .sm\\:w-28 {
      width: calc(var(--spacing) * 28);
    }
    .sm\\:w-40 {
      width: calc(var(--spacing) * 40);
    }
    .sm\\:w-full {
      width: 100%;
    }
    .sm\\:max-w-lg {
      max-width: var(--container-lg);
    }
    .sm\\:max-w-md {
      max-width: var(--container-md);
    }
    .sm\\:max-w-sm {
      max-width: var(--container-sm);
    }
    .sm\\:max-w-xl {
      max-width: var(--container-xl);
    }
    .sm\\:flex-1 {
      flex: 1;
    }
    .sm\\:shrink-0 {
      flex-shrink: 0;
    }
    .sm\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .sm\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .sm\\:grid-cols-7 {
      grid-template-columns: repeat(7, minmax(0, 1fr));
    }
    .sm\\:grid-cols-8 {
      grid-template-columns: repeat(8, minmax(0, 1fr));
    }
    .sm\\:flex-row-reverse {
      flex-direction: row-reverse;
    }
    .sm\\:items-center {
      align-items: center;
    }
    .sm\\:items-end {
      align-items: flex-end;
    }
    .sm\\:justify-between {
      justify-content: space-between;
    }
    .sm\\:justify-center {
      justify-content: center;
    }
    .sm\\:justify-end {
      justify-content: flex-end;
    }
    .sm\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
    .sm\\:gap-4 {
      gap: calc(var(--spacing) * 4);
    }
    .sm\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
    .sm\\:gap-12 {
      gap: calc(var(--spacing) * 12);
    }
    :where(.sm\\:space-y-0 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: 0;
      margin-block-end: 0;
    }
    :where(.sm\\:space-y-4 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.sm\\:space-y-6 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
    .sm\\:gap-x-4 {
      column-gap: calc(var(--spacing) * 4);
    }
    :where(.sm\\:space-x-3 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 3) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-x-reverse)));
    }
    :where(.sm\\:space-x-5 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 5) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-x-reverse)));
    }
    :where(.sm\\:space-x-10 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 10) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 10) * calc(1 - var(--tw-space-x-reverse)));
    }
    :where(.sm\\:space-x-reverse > :not(:last-child)) {
      --tw-space-x-reverse: 1;
    }
    .sm\\:rounded-lg {
      border-radius: var(--radius-lg);
    }
    .sm\\:p-0 {
      padding: 0px;
    }
    .sm\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
    .sm\\:px-0 {
      padding-inline: 0px;
    }
    .sm\\:px-4 {
      padding-inline: calc(var(--spacing) * 4);
    }
    .sm\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
    .sm\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
    .sm\\:px-10 {
      padding-inline: calc(var(--spacing) * 10);
    }
    .sm\\:py-4 {
      padding-block: calc(var(--spacing) * 4);
    }
    .sm\\:py-6 {
      padding-block: calc(var(--spacing) * 6);
    }
    .sm\\:py-32 {
      padding-block: calc(var(--spacing) * 32);
    }
    .sm\\:pt-0 {
      padding-top: 0px;
    }
    .sm\\:pt-1 {
      padding-top: var(--spacing);
    }
    .sm\\:pt-8 {
      padding-top: calc(var(--spacing) * 8);
    }
    .sm\\:pr-6 {
      padding-right: calc(var(--spacing) * 6);
    }
    .sm\\:pl-6 {
      padding-left: calc(var(--spacing) * 6);
    }
    .sm\\:text-left {
      text-align: left;
    }
    .sm\\:align-middle {
      vertical-align: middle;
    }
    .sm\\:text-2xl {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
    .sm\\:text-3xl {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
    .sm\\:text-4xl {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
    .sm\\:text-5xl {
      font-size: var(--text-5xl);
      line-height: var(--tw-leading, var(--text-5xl--line-height));
    }
    .sm\\:text-base {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    .sm\\:text-sm {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .sm\\:text-xl {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
    .sm\\:duration-200 {
      --tw-duration: 200ms;
      transition-duration: 200ms;
    }
    .sm\\:data-closed\\:translate-y-0[data-closed] {
      --tw-translate-y: 0px;
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
    .sm\\:data-closed\\:scale-95[data-closed] {
      --tw-scale-x: 95%;
      --tw-scale-y: 95%;
      --tw-scale-z: 95%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  @media (width >= 48rem) {
    .md\\:right-2 {
      right: calc(var(--spacing) * 2);
    }
    .md\\:bottom-2 {
      bottom: calc(var(--spacing) * 2);
    }
    .md\\:-left-12 {
      left: calc(var(--spacing) * -12);
    }
    .md\\:col-span-1 {
      grid-column: span 1 / span 1;
    }
    .md\\:col-span-2 {
      grid-column: span 2 / span 2;
    }
    .md\\:col-span-3 {
      grid-column: span 3 / span 3;
    }
    .md\\:col-span-4 {
      grid-column: span 4 / span 4;
    }
    .md\\:col-span-5 {
      grid-column: span 5 / span 5;
    }
    .md\\:col-span-7 {
      grid-column: span 7 / span 7;
    }
    .md\\:col-span-9 {
      grid-column: span 9 / span 9;
    }
    .md\\:col-span-10 {
      grid-column: span 10 / span 10;
    }
    .md\\:m-4 {
      margin: calc(var(--spacing) * 4);
    }
    .md\\:m-5 {
      margin: calc(var(--spacing) * 5);
    }
    .md\\:mx-0 {
      margin-inline: 0px;
    }
    .md\\:mx-4 {
      margin-inline: calc(var(--spacing) * 4);
    }
    .md\\:mx-5 {
      margin-inline: calc(var(--spacing) * 5);
    }
    .md\\:mx-auto {
      margin-inline: auto;
    }
    .md\\:my-4 {
      margin-block: calc(var(--spacing) * 4);
    }
    .md\\:my-6 {
      margin-block: calc(var(--spacing) * 6);
    }
    .md\\:my-8 {
      margin-block: calc(var(--spacing) * 8);
    }
    .md\\:my-10 {
      margin-block: calc(var(--spacing) * 10);
    }
    .md\\:my-20 {
      margin-block: calc(var(--spacing) * 20);
    }
    .md\\:-mt-20 {
      margin-top: calc(var(--spacing) * -20);
    }
    .md\\:mt-0 {
      margin-top: 0px;
    }
    .md\\:mt-2 {
      margin-top: calc(var(--spacing) * 2);
    }
    .md\\:mt-5 {
      margin-top: calc(var(--spacing) * 5);
    }
    .md\\:mt-6 {
      margin-top: calc(var(--spacing) * 6);
    }
    .md\\:mt-10 {
      margin-top: calc(var(--spacing) * 10);
    }
    .md\\:mt-14 {
      margin-top: calc(var(--spacing) * 14);
    }
    .md\\:mt-20 {
      margin-top: calc(var(--spacing) * 20);
    }
    .md\\:mb-0 {
      margin-bottom: 0px;
    }
    .md\\:mb-2 {
      margin-bottom: calc(var(--spacing) * 2);
    }
    .md\\:mb-4 {
      margin-bottom: calc(var(--spacing) * 4);
    }
    .md\\:mb-6 {
      margin-bottom: calc(var(--spacing) * 6);
    }
    .md\\:mb-10 {
      margin-bottom: calc(var(--spacing) * 10);
    }
    .md\\:ml-12 {
      margin-left: calc(var(--spacing) * 12);
    }
    .md\\:block {
      display: block;
    }
    .md\\:flex {
      display: flex;
    }
    .md\\:hidden {
      display: none;
    }
    .md\\:inline-flex {
      display: inline-flex;
    }
    .md\\:h-5 {
      height: calc(var(--spacing) * 5);
    }
    .md\\:h-16 {
      height: calc(var(--spacing) * 16);
    }
    .md\\:h-20 {
      height: calc(var(--spacing) * 20);
    }
    .md\\:h-24 {
      height: calc(var(--spacing) * 24);
    }
    .md\\:h-32 {
      height: calc(var(--spacing) * 32);
    }
    .md\\:h-40 {
      height: calc(var(--spacing) * 40);
    }
    .md\\:h-44 {
      height: calc(var(--spacing) * 44);
    }
    .md\\:h-96 {
      height: calc(var(--spacing) * 96);
    }
    .md\\:w-1\\/2 {
      width: calc(1 / 2 * 100%);
    }
    .md\\:w-1\\/3 {
      width: calc(1 / 3 * 100%);
    }
    .md\\:w-2\\/3 {
      width: calc(2 / 3 * 100%);
    }
    .md\\:w-3\\/4 {
      width: calc(3 / 4 * 100%);
    }
    .md\\:w-5 {
      width: calc(var(--spacing) * 5);
    }
    .md\\:w-6\\/12 {
      width: calc(6 / 12 * 100%);
    }
    .md\\:w-7\\/12 {
      width: calc(7 / 12 * 100%);
    }
    .md\\:w-10\\/12 {
      width: calc(10 / 12 * 100%);
    }
    .md\\:w-14 {
      width: calc(var(--spacing) * 14);
    }
    .md\\:w-20 {
      width: calc(var(--spacing) * 20);
    }
    .md\\:w-24 {
      width: calc(var(--spacing) * 24);
    }
    .md\\:w-32 {
      width: calc(var(--spacing) * 32);
    }
    .md\\:w-40 {
      width: calc(var(--spacing) * 40);
    }
    .md\\:w-44 {
      width: calc(var(--spacing) * 44);
    }
    .md\\:w-72 {
      width: calc(var(--spacing) * 72);
    }
    .md\\:w-\\[30\\%\\] {
      width: 30%;
    }
    .md\\:w-auto {
      width: auto;
    }
    .md\\:w-full {
      width: 100%;
    }
    .md\\:max-w-2xl {
      max-width: var(--container-2xl);
    }
    .md\\:max-w-3xl {
      max-width: var(--container-3xl);
    }
    .md\\:max-w-4xl {
      max-width: var(--container-4xl);
    }
    .md\\:max-w-6xl {
      max-width: var(--container-6xl);
    }
    .md\\:max-w-none {
      max-width: none;
    }
    .md\\:flex-1 {
      flex: 1;
    }
    .md\\:flex-auto {
      flex: auto;
    }
    .md\\:list-disc {
      list-style-type: disc;
    }
    .md\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .md\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .md\\:grid-cols-5 {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .md\\:grid-cols-9 {
      grid-template-columns: repeat(9, minmax(0, 1fr));
    }
    .md\\:flex-row {
      flex-direction: row;
    }
    .md\\:flex-row-reverse {
      flex-direction: row-reverse;
    }
    .md\\:items-center {
      align-items: center;
    }
    .md\\:items-start {
      align-items: flex-start;
    }
    .md\\:justify-between {
      justify-content: space-between;
    }
    .md\\:justify-center {
      justify-content: center;
    }
    .md\\:justify-start {
      justify-content: flex-start;
    }
    .md\\:gap-4 {
      gap: calc(var(--spacing) * 4);
    }
    .md\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
    .md\\:gap-7 {
      gap: calc(var(--spacing) * 7);
    }
    .md\\:gap-8 {
      gap: calc(var(--spacing) * 8);
    }
    :where(.md\\:space-y-5 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.md\\:space-y-6 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.md\\:space-y-7 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 7) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 7) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.md\\:space-y-8 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.md\\:space-y-10 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 10) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 10) * calc(1 - var(--tw-space-y-reverse)));
    }
    .md\\:gap-x-6 {
      column-gap: calc(var(--spacing) * 6);
    }
    :where(.md\\:space-x-3 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 3) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-x-reverse)));
    }
    :where(.md\\:space-x-4 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
    }
    :where(.md\\:divide-y-0 > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(0px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    }
    .md\\:rounded-r-\\[78px\\] {
      border-top-right-radius: 78px;
      border-bottom-right-radius: 78px;
    }
    .md\\:border-0 {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
    .md\\:border-t-2 {
      border-top-style: var(--tw-border-style);
      border-top-width: 2px;
    }
    .md\\:border-r-2 {
      border-right-style: var(--tw-border-style);
      border-right-width: 2px;
    }
    .md\\:border-b {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
    }
    .md\\:border-l-0 {
      border-left-style: var(--tw-border-style);
      border-left-width: 0px;
    }
    .md\\:border-l-8 {
      border-left-style: var(--tw-border-style);
      border-left-width: 8px;
    }
    .md\\:border-charcoal-200 {
      border-color: var(--color-charcoal-200);
    }
    .md\\:p-0 {
      padding: 0px;
    }
    .md\\:p-2 {
      padding: calc(var(--spacing) * 2);
    }
    .md\\:p-3 {
      padding: calc(var(--spacing) * 3);
    }
    .md\\:p-5 {
      padding: calc(var(--spacing) * 5);
    }
    .md\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
    .md\\:p-12 {
      padding: calc(var(--spacing) * 12);
    }
    .md\\:px-0 {
      padding-inline: 0px;
    }
    .md\\:px-2 {
      padding-inline: calc(var(--spacing) * 2);
    }
    .md\\:px-3 {
      padding-inline: calc(var(--spacing) * 3);
    }
    .md\\:px-4 {
      padding-inline: calc(var(--spacing) * 4);
    }
    .md\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
    .md\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
    .md\\:px-7 {
      padding-inline: calc(var(--spacing) * 7);
    }
    .md\\:px-8 {
      padding-inline: calc(var(--spacing) * 8);
    }
    .md\\:px-12 {
      padding-inline: calc(var(--spacing) * 12);
    }
    .md\\:px-14 {
      padding-inline: calc(var(--spacing) * 14);
    }
    .md\\:px-16 {
      padding-inline: calc(var(--spacing) * 16);
    }
    .md\\:px-20 {
      padding-inline: calc(var(--spacing) * 20);
    }
    .md\\:py-0 {
      padding-block: 0px;
    }
    .md\\:py-2 {
      padding-block: calc(var(--spacing) * 2);
    }
    .md\\:py-4 {
      padding-block: calc(var(--spacing) * 4);
    }
    .md\\:py-6 {
      padding-block: calc(var(--spacing) * 6);
    }
    .md\\:py-8 {
      padding-block: calc(var(--spacing) * 8);
    }
    .md\\:py-10 {
      padding-block: calc(var(--spacing) * 10);
    }
    .md\\:pt-2 {
      padding-top: calc(var(--spacing) * 2);
    }
    .md\\:pt-4 {
      padding-top: calc(var(--spacing) * 4);
    }
    .md\\:pt-6 {
      padding-top: calc(var(--spacing) * 6);
    }
    .md\\:pt-8 {
      padding-top: calc(var(--spacing) * 8);
    }
    .md\\:pt-12 {
      padding-top: calc(var(--spacing) * 12);
    }
    .md\\:pr-6 {
      padding-right: calc(var(--spacing) * 6);
    }
    .md\\:pb-0 {
      padding-bottom: 0px;
    }
    .md\\:pb-2 {
      padding-bottom: calc(var(--spacing) * 2);
    }
    .md\\:pb-4 {
      padding-bottom: calc(var(--spacing) * 4);
    }
    .md\\:pb-6 {
      padding-bottom: calc(var(--spacing) * 6);
    }
    .md\\:pb-8 {
      padding-bottom: calc(var(--spacing) * 8);
    }
    .md\\:pb-12 {
      padding-bottom: calc(var(--spacing) * 12);
    }
    .md\\:pb-14 {
      padding-bottom: calc(var(--spacing) * 14);
    }
    .md\\:pb-20 {
      padding-bottom: calc(var(--spacing) * 20);
    }
    .md\\:pl-2 {
      padding-left: calc(var(--spacing) * 2);
    }
    .md\\:text-left {
      text-align: left;
    }
    .md\\:text-2xl {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
    .md\\:text-3xl {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
    .md\\:text-4xl {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
    .md\\:text-base {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    .md\\:text-lg {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
    .md\\:text-sm {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .md\\:text-xl {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
    .md\\:text-white {
      color: var(--color-white);
    }
  }
  @media (width >= 64rem) {
    .lg\\:col-span-2 {
      grid-column: span 2 / span 2;
    }
    .lg\\:col-span-3 {
      grid-column: span 3 / span 3;
    }
    .lg\\:col-span-4 {
      grid-column: span 4 / span 4;
    }
    .lg\\:col-span-6 {
      grid-column: span 6 / span 6;
    }
    .lg\\:col-span-8 {
      grid-column: span 8 / span 8;
    }
    .lg\\:col-span-9 {
      grid-column: span 9 / span 9;
    }
    .lg\\:col-span-10 {
      grid-column: span 10 / span 10;
    }
    .lg\\:col-span-12 {
      grid-column: span 12 / span 12;
    }
    .lg\\:col-start-1 {
      grid-column-start: 1;
    }
    .lg\\:col-start-2 {
      grid-column-start: 2;
    }
    .lg\\:col-start-3 {
      grid-column-start: 3;
    }
    .lg\\:col-start-4 {
      grid-column-start: 4;
    }
    .lg\\:col-start-5 {
      grid-column-start: 5;
    }
    .lg\\:col-start-7 {
      grid-column-start: 7;
    }
    .lg\\:row-start-1 {
      grid-row-start: 1;
    }
    .lg\\:m-0 {
      margin: 0px;
    }
    .lg\\:m-8 {
      margin: calc(var(--spacing) * 8);
    }
    .lg\\:mx-4 {
      margin-inline: calc(var(--spacing) * 4);
    }
    .lg\\:mx-5 {
      margin-inline: calc(var(--spacing) * 5);
    }
    .lg\\:mx-10 {
      margin-inline: calc(var(--spacing) * 10);
    }
    .lg\\:-my-8 {
      margin-block: calc(var(--spacing) * -8);
    }
    .lg\\:my-2 {
      margin-block: calc(var(--spacing) * 2);
    }
    .lg\\:my-8 {
      margin-block: calc(var(--spacing) * 8);
    }
    .lg\\:my-20 {
      margin-block: calc(var(--spacing) * 20);
    }
    .lg\\:mt-0 {
      margin-top: 0px;
    }
    .lg\\:mt-2 {
      margin-top: calc(var(--spacing) * 2);
    }
    .lg\\:mt-4 {
      margin-top: calc(var(--spacing) * 4);
    }
    .lg\\:mt-5 {
      margin-top: calc(var(--spacing) * 5);
    }
    .lg\\:mt-6 {
      margin-top: calc(var(--spacing) * 6);
    }
    .lg\\:mt-8 {
      margin-top: calc(var(--spacing) * 8);
    }
    .lg\\:mt-10 {
      margin-top: calc(var(--spacing) * 10);
    }
    .lg\\:mt-18 {
      margin-top: calc(var(--spacing) * 18);
    }
    .lg\\:mr-0 {
      margin-right: 0px;
    }
    .lg\\:mb-10 {
      margin-bottom: calc(var(--spacing) * 10);
    }
    .lg\\:ml-5 {
      margin-left: calc(var(--spacing) * 5);
    }
    .lg\\:ml-8 {
      margin-left: calc(var(--spacing) * 8);
    }
    .lg\\:ml-16 {
      margin-left: calc(var(--spacing) * 16);
    }
    .lg\\:block {
      display: block;
    }
    .lg\\:flex {
      display: flex;
    }
    .lg\\:grid {
      display: grid;
    }
    .lg\\:hidden {
      display: none;
    }
    .lg\\:inline {
      display: inline;
    }
    .lg\\:size-64 {
      width: calc(var(--spacing) * 64);
      height: calc(var(--spacing) * 64);
    }
    .lg\\:size-72 {
      width: calc(var(--spacing) * 72);
      height: calc(var(--spacing) * 72);
    }
    .lg\\:h-10 {
      height: calc(var(--spacing) * 10);
    }
    .lg\\:h-12 {
      height: calc(var(--spacing) * 12);
    }
    .lg\\:h-14 {
      height: calc(var(--spacing) * 14);
    }
    .lg\\:h-48 {
      height: calc(var(--spacing) * 48);
    }
    .lg\\:h-60 {
      height: calc(var(--spacing) * 60);
    }
    .lg\\:h-72 {
      height: calc(var(--spacing) * 72);
    }
    .lg\\:h-80 {
      height: calc(var(--spacing) * 80);
    }
    .lg\\:h-\\[75vh\\] {
      height: 75vh;
    }
    .lg\\:h-fit {
      height: fit-content;
    }
    .lg\\:w-1\\/2 {
      width: calc(1 / 2 * 100%);
    }
    .lg\\:w-2xl {
      width: var(--container-2xl);
    }
    .lg\\:w-3\\/5 {
      width: calc(3 / 5 * 100%);
    }
    .lg\\:w-4\\/5 {
      width: calc(4 / 5 * 100%);
    }
    .lg\\:w-10 {
      width: calc(var(--spacing) * 10);
    }
    .lg\\:w-12 {
      width: calc(var(--spacing) * 12);
    }
    .lg\\:w-52 {
      width: calc(var(--spacing) * 52);
    }
    .lg\\:w-60 {
      width: calc(var(--spacing) * 60);
    }
    .lg\\:w-72 {
      width: calc(var(--spacing) * 72);
    }
    .lg\\:w-\\[33vw\\] {
      width: 33vw;
    }
    .lg\\:w-auto {
      width: auto;
    }
    .lg\\:w-full {
      width: 100%;
    }
    .lg\\:max-w-3xl {
      max-width: var(--container-3xl);
    }
    .lg\\:max-w-4xl {
      max-width: var(--container-4xl);
    }
    .lg\\:max-w-none {
      max-width: none;
    }
    .lg\\:-translate-x-0 {
      --tw-translate-x: 0px;
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
    .lg\\:translate-x-0 {
      --tw-translate-x: 0px;
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
    .lg\\:grid-cols-1 {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    .lg\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .lg\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .lg\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .lg\\:grid-cols-5 {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .lg\\:grid-cols-7 {
      grid-template-columns: repeat(7, minmax(0, 1fr));
    }
    .lg\\:grid-cols-10 {
      grid-template-columns: repeat(10, minmax(0, 1fr));
    }
    .lg\\:grid-cols-12 {
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }
    .lg\\:flex-row {
      flex-direction: row;
    }
    .lg\\:items-center {
      align-items: center;
    }
    .lg\\:justify-end {
      justify-content: flex-end;
    }
    .lg\\:justify-start {
      justify-content: flex-start;
    }
    .lg\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
    .lg\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
    .lg\\:gap-8 {
      gap: calc(var(--spacing) * 8);
    }
    .lg\\:gap-10 {
      gap: calc(var(--spacing) * 10);
    }
    .lg\\:gap-11 {
      gap: calc(var(--spacing) * 11);
    }
    .lg\\:gap-16 {
      gap: calc(var(--spacing) * 16);
    }
    :where(.lg\\:space-y-2 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.lg\\:space-y-4 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.lg\\:space-y-6 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.lg\\:space-y-8 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)));
    }
    :where(.lg\\:space-y-10 > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 10) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 10) * calc(1 - var(--tw-space-y-reverse)));
    }
    .lg\\:gap-x-8 {
      column-gap: calc(var(--spacing) * 8);
    }
    :where(.lg\\:space-x-1 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(var(--spacing) * var(--tw-space-x-reverse));
      margin-inline-end: calc(var(--spacing) * calc(1 - var(--tw-space-x-reverse)));
    }
    :where(.lg\\:space-x-4 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
    }
    :where(.lg\\:space-x-10 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 10) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 10) * calc(1 - var(--tw-space-x-reverse)));
    }
    .lg\\:gap-y-14 {
      row-gap: calc(var(--spacing) * 14);
    }
    .lg\\:rounded-lg {
      border-radius: var(--radius-lg);
    }
    .lg\\:rounded-xl {
      border-radius: var(--radius-xl);
    }
    .lg\\:border-l-4 {
      border-left-style: var(--tw-border-style);
      border-left-width: 4px;
    }
    .lg\\:bg-transparent {
      background-color: transparent;
    }
    .lg\\:p-0 {
      padding: 0px;
    }
    .lg\\:p-2 {
      padding: calc(var(--spacing) * 2);
    }
    .lg\\:p-3 {
      padding: calc(var(--spacing) * 3);
    }
    .lg\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
    .lg\\:p-8 {
      padding: calc(var(--spacing) * 8);
    }
    .lg\\:p-10 {
      padding: calc(var(--spacing) * 10);
    }
    .lg\\:p-20 {
      padding: calc(var(--spacing) * 20);
    }
    .lg\\:px-0 {
      padding-inline: 0px;
    }
    .lg\\:px-3 {
      padding-inline: calc(var(--spacing) * 3);
    }
    .lg\\:px-4 {
      padding-inline: calc(var(--spacing) * 4);
    }
    .lg\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
    .lg\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
    .lg\\:px-8 {
      padding-inline: calc(var(--spacing) * 8);
    }
    .lg\\:px-9 {
      padding-inline: calc(var(--spacing) * 9);
    }
    .lg\\:px-10 {
      padding-inline: calc(var(--spacing) * 10);
    }
    .lg\\:px-14 {
      padding-inline: calc(var(--spacing) * 14);
    }
    .lg\\:px-16 {
      padding-inline: calc(var(--spacing) * 16);
    }
    .lg\\:px-20 {
      padding-inline: calc(var(--spacing) * 20);
    }
    .lg\\:py-0 {
      padding-block: 0px;
    }
    .lg\\:py-4 {
      padding-block: calc(var(--spacing) * 4);
    }
    .lg\\:py-5 {
      padding-block: calc(var(--spacing) * 5);
    }
    .lg\\:py-6 {
      padding-block: calc(var(--spacing) * 6);
    }
    .lg\\:py-8 {
      padding-block: calc(var(--spacing) * 8);
    }
    .lg\\:py-10 {
      padding-block: calc(var(--spacing) * 10);
    }
    .lg\\:py-11 {
      padding-block: calc(var(--spacing) * 11);
    }
    .lg\\:py-12 {
      padding-block: calc(var(--spacing) * 12);
    }
    .lg\\:py-16 {
      padding-block: calc(var(--spacing) * 16);
    }
    .lg\\:pt-2 {
      padding-top: calc(var(--spacing) * 2);
    }
    .lg\\:pt-3 {
      padding-top: calc(var(--spacing) * 3);
    }
    .lg\\:pt-5 {
      padding-top: calc(var(--spacing) * 5);
    }
    .lg\\:pt-8 {
      padding-top: calc(var(--spacing) * 8);
    }
    .lg\\:pt-12 {
      padding-top: calc(var(--spacing) * 12);
    }
    .lg\\:pr-11 {
      padding-right: calc(var(--spacing) * 11);
    }
    .lg\\:pb-5 {
      padding-bottom: calc(var(--spacing) * 5);
    }
    .lg\\:pb-8 {
      padding-bottom: calc(var(--spacing) * 8);
    }
    .lg\\:pb-10 {
      padding-bottom: calc(var(--spacing) * 10);
    }
    .lg\\:pl-3 {
      padding-left: calc(var(--spacing) * 3);
    }
    .lg\\:pl-7 {
      padding-left: calc(var(--spacing) * 7);
    }
    .lg\\:pl-8 {
      padding-left: calc(var(--spacing) * 8);
    }
    .lg\\:text-center {
      text-align: center;
    }
    .lg\\:text-left {
      text-align: left;
    }
    .lg\\:text-2xl {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
    .lg\\:text-3xl {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
    .lg\\:text-4xl {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
    .lg\\:text-5xl {
      font-size: var(--text-5xl);
      line-height: var(--tw-leading, var(--text-5xl--line-height));
    }
    .lg\\:text-6xl {
      font-size: var(--text-6xl);
      line-height: var(--tw-leading, var(--text-6xl--line-height));
    }
    .lg\\:text-7xl {
      font-size: var(--text-7xl);
      line-height: var(--tw-leading, var(--text-7xl--line-height));
    }
    .lg\\:text-lg {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
    .lg\\:text-balance {
      text-wrap: balance;
    }
    .lg\\:shadow-lg {
      --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  @media (width >= 80rem) {
    .xl\\:right-2 {
      right: calc(var(--spacing) * 2);
    }
    .xl\\:col-span-2 {
      grid-column: span 2 / span 2;
    }
    .xl\\:col-span-3 {
      grid-column: span 3 / span 3;
    }
    .xl\\:col-span-4 {
      grid-column: span 4 / span 4;
    }
    .xl\\:col-span-5 {
      grid-column: span 5 / span 5;
    }
    .xl\\:col-span-8 {
      grid-column: span 8 / span 8;
    }
    .xl\\:col-span-9 {
      grid-column: span 9 / span 9;
    }
    .xl\\:col-start-2 {
      grid-column-start: 2;
    }
    .xl\\:mx-auto {
      margin-inline: auto;
    }
    .xl\\:my-10 {
      margin-block: calc(var(--spacing) * 10);
    }
    .xl\\:mt-14 {
      margin-top: calc(var(--spacing) * 14);
    }
    .xl\\:ml-2 {
      margin-left: calc(var(--spacing) * 2);
    }
    .xl\\:ml-7 {
      margin-left: calc(var(--spacing) * 7);
    }
    .xl\\:flex {
      display: flex;
    }
    .xl\\:h-8 {
      height: calc(var(--spacing) * 8);
    }
    .xl\\:h-10 {
      height: calc(var(--spacing) * 10);
    }
    .xl\\:h-20 {
      height: calc(var(--spacing) * 20);
    }
    .xl\\:h-44 {
      height: calc(var(--spacing) * 44);
    }
    .xl\\:h-screen {
      height: 100vh;
    }
    .xl\\:w-4\\/5 {
      width: calc(4 / 5 * 100%);
    }
    .xl\\:w-44 {
      width: calc(var(--spacing) * 44);
    }
    .xl\\:max-w-2xl {
      max-width: var(--container-2xl);
    }
    .xl\\:max-w-5xl {
      max-width: var(--container-5xl);
    }
    .xl\\:max-w-7xl {
      max-width: var(--container-7xl);
    }
    .xl\\:columns-4 {
      columns: 4;
    }
    .xl\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .xl\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .xl\\:grid-cols-6 {
      grid-template-columns: repeat(6, minmax(0, 1fr));
    }
    .xl\\:items-center {
      align-items: center;
    }
    .xl\\:gap-8 {
      gap: calc(var(--spacing) * 8);
    }
    .xl\\:gap-x-8 {
      column-gap: calc(var(--spacing) * 8);
    }
    :where(.xl\\:space-x-4 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
    }
    :where(.xl\\:space-x-12 > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 12) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 12) * calc(1 - var(--tw-space-x-reverse)));
    }
    .xl\\:px-0 {
      padding-inline: 0px;
    }
    .xl\\:px-16 {
      padding-inline: calc(var(--spacing) * 16);
    }
    .xl\\:pt-3 {
      padding-top: calc(var(--spacing) * 3);
    }
    .xl\\:pl-6 {
      padding-left: calc(var(--spacing) * 6);
    }
    .xl\\:text-3xl {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
    .xl\\:text-6xl {
      font-size: var(--text-6xl);
      line-height: var(--tw-leading, var(--text-6xl--line-height));
    }
    .xl\\:text-7xl {
      font-size: var(--text-7xl);
      line-height: var(--tw-leading, var(--text-7xl--line-height));
    }
    .xl\\:text-base {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    .xl\\:text-lg {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
    .xl\\:text-xl {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  @media print {
    .print\\:block {
      display: block;
    }
    .print\\:hidden {
      display: none;
    }
  }
}
@layer base {
  button:not(:disabled),
  [role='button']:not(:disabled) {
    cursor: pointer;
  }
}
.wysiwyg .ProseMirror:focus {
  outline: none;
  box-shadow: none;
}
.wysiwyg .ProseMirror a {
  pointer-events: none;
}
.uppy-Root {
  font-family: 'BCSans', sans-serif;
}
.uppy-Root label {
  font-family: 'BCSans', sans-serif;
}
.uppy-Root .uppy-u-reset {
  font-family: 'BCSans', sans-serif;
}
@layer base {
  input:where([type='text']),input:where(:not([type])),input:where([type='email']),input:where([type='url']),input:where([type='password']),input:where([type='number']),input:where([type='date']),input:where([type='datetime-local']),input:where([type='month']),input:where([type='search']),input:where([type='tel']),input:where([type='time']),input:where([type='week']),select:where([multiple]),textarea,select {
    appearance: none;
    background-color: #fff;
    border-color: oklch(55.1% 0.027 264.364);
    border-width: 1px;
    border-radius: 0px;
    padding-top: 0.5rem;
    padding-right: 0.75rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    font-size: 1rem;
    line-height: 1.5rem;
    --tw-shadow: 0 0 #0000;
    &:focus {
      outline: 2px solid transparent;
      outline-offset: 2px;
      --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-color: oklch(54.6% 0.245 262.881);
      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      border-color: oklch(54.6% 0.245 262.881);
    }
  }
  input::placeholder,textarea::placeholder {
    color: oklch(55.1% 0.027 264.364);
    opacity: 1;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-date-and-time-value {
    min-height: 1.5em;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field {
    padding-top: 0;
    padding-bottom: 0;
  }
  select {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    padding-right: 2.5rem;
    print-color-adjust: exact;
  }
  select:where([multiple]),select:where([size]:not([size="1"])) {
    background-image: initial;
    background-position: initial;
    background-repeat: unset;
    background-size: initial;
    padding-right: 0.75rem;
    print-color-adjust: unset;
  }
  input:where([type='checkbox']),input:where([type='radio']) {
    appearance: none;
    padding: 0;
    print-color-adjust: exact;
    display: inline-block;
    vertical-align: middle;
    background-origin: border-box;
    user-select: none;
    flex-shrink: 0;
    height: 1rem;
    width: 1rem;
    color: oklch(54.6% 0.245 262.881);
    background-color: #fff;
    border-color: oklch(55.1% 0.027 264.364);
    border-width: 1px;
    --tw-shadow: 0 0 #0000;
  }
  input:where([type='checkbox']) {
    border-radius: 0px;
  }
  input:where([type='radio']) {
    border-radius: 100%;
  }
  input:where([type='checkbox']):focus,input:where([type='radio']):focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
    --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: oklch(54.6% 0.245 262.881);
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  input:where([type='checkbox']):checked,input:where([type='radio']):checked {
    border-color: transparent;
    background-color: currentColor;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
  input:where([type='checkbox']):checked {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    @media (forced-colors: active) {
      appearance: auto;
    }
  }
  input:where([type='radio']):checked {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    @media (forced-colors: active) {
      appearance: auto;
    }
  }
  input:where([type='checkbox']):checked:hover,input:where([type='checkbox']):checked:focus,input:where([type='radio']):checked:hover,input:where([type='radio']):checked:focus {
    border-color: transparent;
    background-color: currentColor;
  }
  input:where([type='checkbox']):indeterminate {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    border-color: transparent;
    background-color: currentColor;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    @media (forced-colors: active) {
      appearance: auto;
    }
  }
  input:where([type='checkbox']):indeterminate:hover,input:where([type='checkbox']):indeterminate:focus {
    border-color: transparent;
    background-color: currentColor;
  }
  input:where([type='file']) {
    background: unset;
    border-color: inherit;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-size: unset;
    line-height: inherit;
  }
  input:where([type='file']):focus {
    outline: 1px solid ButtonText;
    outline: 1px auto -webkit-focus-ring-color;
  }
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-spacing-x {
  syntax: "<length>";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-spacing-y {
  syntax: "<length>";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-scroll-snap-strictness {
  syntax: "*";
  inherits: false;
  initial-value: proximity;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse-blur {
  0%,
    50%,
    100% {
    transform: scale(1);
    filter: blur(0px);
  }
  25% {
    transform: scale(0.6);
    filter: blur(2px);
  }
  75% {
    transform: scale(1.4);
    filter: blur(2px);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
      --tw-space-x-reverse: 0;
      --tw-border-spacing-x: 0;
      --tw-border-spacing-y: 0;
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-scroll-snap-strictness: proximity;
      --tw-space-y-reverse: 0;
      --tw-divide-x-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-tracking: initial;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./src/assets/main.css","webpack://./node_modules/@bcgov/bc-sans/css/BCSans.css","webpack://./node_modules/tailwindcss/index.css","webpack://./src/assets/colors.css","webpack://./src/assets/buttons.css"],"names":[],"mappings":"AAAA,iEAAA;ACgEW,iBAAQ;AAhEnB;ECAA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,oHAA2K;EAJlK;EAMX;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,oHAAyK;EAJhK;EAMX;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,oHAAqK;EAJ5J;EAMX;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,oHAAiL;EAJxK;EAMX;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,oHAAuK;EAJ9J;EAMX;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,sHAAmL;EAJ1K;AD9ByC;AEApD,yCAAyC;AAEzC;EACE;IFKA,iCAAkC;IEChC;8BAE0B;IAG1B,0CAA0C;IAM1C,0CAA0C;IAoH1C,4CAA4C;IAG5C,4CAA4C;IAC5C,4CAA4C;IAE5C,4CAA4C;IAiC5C,8CAA8C;IAsJ9C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAUlB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IAEtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAQ1B,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IAGxB,0BAA0B;IAE1B,wBAAwB;IAIxB,qBAAqB;IAMrB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IAEpB,oBAAoB;IAoBpB,6CAA6C;IAiB7C,qCAAqC;IACrC,sCAAsC;IACtC,2CAA2C;IAE3C,uCAAuC;IAoDvC,sBAAsB;IAEtB,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;IC9f3D,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAG5B,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAE5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAG5B,4BAA4B;IAC5B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAG7B,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IAEzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IAGzB,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAE1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IHhD1B,qDAAsD;EERvC;AADJ;AAohBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,8NAcC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EA3BpC;EAoCN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADqB;EAQpC;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAxZnC;AA6ZZ;EACE;IE11BO,oBAAQ;IAAR,mBAAQ;IAAR,uBAAQ;IAAR,+BAAQ;IAAR;MAAA,oBAAQ;IAAA;IAAR;MAAA,WAAQ;MAAR,cAAQ;MAAR,YAAQ;MAAR,WAAQ;MAAR,YAAQ;MAAR,sBAAQ;IAAA;IACZ,iCAAI;IAAT,gCAAI;IAAe;MAAA,iCAAO;IAAA;IAAf;MAAA,gCAAO;IAAA;IAAkB;MAAA,iCAClC;IAAA;IAD0B;MAAA,gCAAO;IAAA;IAGjC;MAC0B,gCAAG;MAAP,+BAAG;MAAhB,kBAAY;IADf;EFs1Ba;EAAnB;IEn2BO,oBAAQ;IAAR,mBAAQ;IAAR,uBAAQ;IAAR,+BAAQ;IAAR;MAAA,oBAAQ;IAAA;IAAR;MAAA,WAAQ;MAAR,cAAQ;MAAR,YAAQ;MAAR,WAAQ;MAAR,YAAQ;MAAR,sBAAQ;IAAA;IACZ,iCAAI;IAAT,gCAAI;IAAe;MAAA,iCAAO;IAAA;IAAf;MAAA,gCAAO;IAAA;IAAkB;MAAA,iCAClC;IAAA;IAD0B;MAAA,gCAAO;IAAA;IAGjC;MAC0B,gCAAG;MAAP,+BAAG;MAAhB,kBAAY;IADf;EF+1Ba;EAAnB;IE72BO,oBAAQ;IAAR,mBAAQ;IAAR,uBAAQ;IAAR,+BAAQ;IAAR;MAAA,oBAAQ;IAAA;IAAR;MAAA,WAAQ;MAAR,cAAQ;MAAR,YAAQ;MAAR,WAAQ;MAAR,YAAQ;MAAR,sBAAQ;IAAA;IACZ,iCAAI;IAAT,gCAAI;IAAc;MAAA,gCAAM;IAAA;IAAb;MAAA,+BAAM;IAAA;IAEf;MAEE,gCAAG;MAAP,+BAAG;MADQ,kBAAY;MACP;QAAA,gCAAM;MAAA;MAAb;QAAA,+BAAM;MAAA;IAFP;EF02Ba;EAAnB;IEj1BO,oBAAQ;IAAR,mBAAQ;IAAR,uBAAQ;IAAR,+BAAQ;IAAR;MAAA,oBAAQ;IAAA;IAAR;MAAA,WAAQ;MAAR,cAAQ;MAAR,YAAQ;MAAR,WAAQ;MAAR,YAAQ;MAAR,sBAAQ;IAAA;IACZ,iCAAI;IAAT,gCAAI;IAAe;MAAA,iCAAO;IAAA;IAAf;MAAA,gCAAO;IAAA;IAAkB;MAAA,iCAClC;IAAA;IAD0B;MAAA,gCAAO;IAAA;IAGjC;MAC0B,gCAAG;MAAP,+BAAG;MAAhB,kBAAY;IADf;EF60Ba;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IFv3BO,gBAAS;IAEhB;MACgD,sCAAI;MAA3C,2CAAQ;MAAR,wBAAQ;MAAC,uCAAmB;MAAgB,uCAAI;MAAC,0BAAQ;MAAR,4DAAQ;MAA5B,yCAAS;MAAT,oCAAS;MAAoB,+BAAgB;IAClF;IACD;MACmB,sCAAI;MAAC,yBAAO;MAAP,2DAAO;MAAtB,yCAAS;MAAT,oCAAS;MAAc,+BAAgB;IAC/C;IACD;MACS,wBAAY;MAAC,sCAAI;IACzB;IACD;MACS,qBAAS;MAAC,sCAAI;IACtB;IACD;MACS,sCAAI;IACZ;IACD;MACS,sCAAI;IACZ;IACD;MACS,4BAAU;MAAV,+BAAU;MAAV,0BAAU;MAAV;QAAA,8BAAU;MAAA;IAClB;EEi2BkB;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IEh4BO,oBAAG;IAAH,mBAAG;IAAH,uBAAG;IAAH;MAAA,uBAAG;MAAH,+EAAG;MAAH,uFAAG;IAAA;IAAH,+BAAG;IAAH;MAAA,oBAAG;IAAA;IACO,iCAAI;IAAb,oCAAQ;IADA,wCAAI;IAAT,uCAAI;IACjB,2BAAS;IAAT,6DAAS;IAAuC;MAAA,iCAAO;IAAA;IAAnB;MAAA,oCAAW;IAAA;IAAtB;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAEjC;MAC4B,kCAAK;MAAX,iCAAK;MAAlB,kBAAY;IADf;EF63Ba;EAAnB;IEx4BO,oBAAG;IAAH,mBAAG;IAAH,uBAAG;IAAH;MAAA,uBAAG;MAAH,+EAAG;MAAH,uFAAG;IAAA;IAAH,+BAAG;IAAH;MAAA,oBAAG;IAAA;IACO,iCAAI;IAAb,oCAAQ;IADA,wCAAI;IAAT,uCAAI;IACjB,2BAAS;IAAT,6DAAS;IAAyC;MAAA,iCAAO;IAAA;IAAnB;MAAA,oCAAW;IAAA;IAAxB;MAAA,2BAAY;MAAZ,6DAAY;IAAA;IAEnC;MAC0B,gCAAG;MAAP,+BAAG;MAAhB,kBAAY;IADf;EFq4Ba;EAAnB;IEh5BO,oBAAG;IAAH,mBAAG;IAAH,uBAAG;IAAH;MAAA,uBAAG;MAAH,+EAAG;MAAH,uFAAG;IAAA;IAAH,+BAAG;IAAH;MAAA,oBAAG;IAAA;IACK,gCAAG;IAAZ,oCAAQ;IADI,wCAAI;IAAX,yCAAM;IACnB,yBAAO;IAAP,2DAAO;IAAsC;MAAA,gCAAM;IAAA;IAAlB;MAAA,oCAAW;IAAA;IAAtB;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAE9B;MAC4B,kCAAK;MAAX,iCAAK;MAAlB,kBAAY;IADf;EF64Ba;EAAnB;IEx3BO,oBAAG;IAAH,mBAAG;IAAH,uBAAG;IAAH;MAAA,uBAAG;MAAH,+EAAG;MAAH,uFAAG;IAAA;IAAH,+BAAG;IAAH;MAAA,oBAAG;IAAA;IACK,iCAAI;IAAb,oCAAQ;IADE,wCAAI;IAAT,uCAAI;IACjB,yBAAO;IAAP,2DAAO;IAAuC;MAAA,iCAAO;IAAA;IAAnB;MAAA,oCAAW;IAAA;IAAtB;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAE/B;MAC0B,gCAAG;MAAP,+BAAG;MAAhB,kBAAY;IADf;EFq3Ba;EAAnB;IEx5BO,oBAAG;IAAH,mBAAG;IAAH,uBAAG;IAAH;MAAA,uBAAG;MAAH,+EAAG;MAAH,uFAAG;IAAA;IAAH,+BAAG;IAAH;MAAA,oBAAG;IAAA;IACJ,gCAAG;IADO,wCAAI;IAAT,6BAAI;IACjB,yBAAO;IAAP,2DAAO;IAA6B;MAAA,gCAAM;IAAA;IAAlB;MAAA,oCAAW;IAAA;IAAtB;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAErB;MAC0B,gCAAG;MAAP,+BAAG;MAAhB,kBAAY;IADf;EFq5Ba;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,qEAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,gBAAmB;IAAnB,gBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,iBAAmB;IAAnB,iBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,kBAAmB;IAAnB,kBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,oEAAmB;IAAnB,4EAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,+EAAmB;IAAnB,uFAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,qEAAmB;IAAnB,6EAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,iFAAmB;IAAnB,yFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,+EAAmB;IAAnB,uFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,+EAAmB;IAAnB,uFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,+EAAmB;IAAnB,uFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,+EAAmB;IAAnB,uFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,+EAAmB;IAAnB,uFAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,gFAAmB;IAAnB,wFAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,2CAAmB;IAAnB,iEAAmB;IAAnB,yEAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,2CAAmB;IAAnB,iEAAmB;IAAnB,yEAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,2CAAmB;IAAnB,wCAAmB;IAAnB,wDAAmB;IAAnB,qEAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,+CAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IEj6BgB,oCAAM;IAAN,iBAAM;IAAC,sCAAkB;IAAlC,oCAAQ;IAA2B,+BAAgB;IAAyD;MAAA;QAAA,0CAAoB;MAAA;IAAA;IAAC;MAAA,0CAAoB;IAAA;IAAsB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,yCAAsB;IAAA;IAAxD;MAAA,wBAAoB;MAApB,mBAAoB;MAApB;QAAA,8BAAoB;QAApB,mBAAoB;MAAA;IAAA;IAAtH;MAAA,uCAA4B;IAAA;IAAC;MAAA,gCAA0B;IAAA;EFi6B/F;EAAnB;IE95BgB,oCAAM;IAAN,iBAAM;IAAC,yBAAkB;IAAlC,oCAAQ;IAA2B,+BAAgB;IAA4B;MAAA;QAAA,0CAAoB;MAAA;IAAA;IAAC;MAAA,0CAAoB;IAAA;IAAsB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,yCAAsB;IAAA;IAAxD;MAAA,wBAAoB;MAApB,mBAAoB;MAApB;QAAA,8BAAoB;QAApB,mBAAoB;MAAA;IAAA;IAAzF;MAAA,gCAA0B;IAAA;EF85BlE;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IEp6BO,0CAAc;IAAC,+BAAgB;IAAoD;MAAA;QAAA,0CAAoB;MAAA;IAAA;IAAsB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,yCAAsB;IAAA;IAAxD;MAAA,wBAAoB;MAApB,mBAAoB;MAApB;QAAA,8BAAoB;QAApB,mBAAoB;MAAA;IAAA;IAA5F;MAAA,2CAAwB;IAAA;IAAC;MAAA,+BAAyB;IAAA;EFo6BtE;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB;MAAA,0CAAmB;IAAA;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IFx4BO,4BAAa;IAAyB,+BAAS;IAAC,0BAAkB;IAApD;MAAA,8BAAuB;IAAA;EEw4BzB;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,4DAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,4GAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,4FAAmB;IAAnB,oDAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,yUAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,mBAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IFp4BA,wBAAyB;EEo4BN;EAAnB;IF53BA,4CAA6C;EE43B1B;EAAnB;IAAA;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,kBAAmB;MAAnB,kBAAmB;MAAnB,0CAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,wBAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IEx4BO,oBAAG;IAAH,mBAAG;IAAH,uBAAG;IAAH;MAAA,uBAAG;MAAH,+EAAG;MAAH,uFAAG;IAAA;IAAH,+BAAG;IAAH;MAAA,oBAAG;IAAA;IACO,iCAAI;IAAb,oCAAQ;IADA,wCAAI;IAAT,uCAAI;IACjB,2BAAS;IAAT,6DAAS;IAAyC;MAAA,iCAAO;IAAA;IAAnB;MAAA,oCAAW;IAAA;IAAxB;MAAA,2BAAY;MAAZ,6DAAY;IAAA;IAEnC;MAC0B,gCAAG;MAAP,+BAAG;MAAhB,kBAAY;IADf;EFq4Ba;EAAnB;IEj6BgB,oCAAM;IAAN,iBAAM;IAAC,sCAAkB;IAAlC,oCAAQ;IAA2B,+BAAgB;IAAyD;MAAA;QAAA,0CAAoB;MAAA;IAAA;IAAC;MAAA,0CAAoB;IAAA;IAAsB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,yCAAsB;IAAA;IAAxD;MAAA,wBAAoB;MAApB,mBAAoB;MAApB;QAAA,8BAAoB;QAApB,mBAAoB;MAAA;IAAA;IAAtH;MAAA,uCAA4B;IAAA;IAAC;MAAA,gCAA0B;IAAA;EFi6B/F;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,4GAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,4GAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,mCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,2CAAmB;IAAA;IAAnB;MAAA,2CAAmB;IAAA;IAAnB;MAAA,2CAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,kEAAmB;MAAnB,sIAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,wRAAmB;MAAnB,gRAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,4GAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;IAAnB;MAAA,8BAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,iBAAmB;IAAnB,iBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MEx4BO,oBAAG;MAAH,mBAAG;MAAH,uBAAG;IFw4BS;IEx4BZ;MAAA,uBAAG;MAAH,+EAAG;MAAH,uFAAG;IAAA;IFw4BV;MEx4BO,+BAAG;IFw4BS;IEx4BZ;MAAA,oBAAG;IAAA;IFw4BV;MEv4BiB,iCAAI;MAAb,oCAAQ;MADA,wCAAI;MAAT,uCAAI;MACjB,2BAAS;MAAT,6DAAS;IFu4BY;IEv4B6B;MFu4BhD;QEv4BgD,iCAAO;QAAnB,oCAAW;QAAxB,2BAAY;QAAZ,6DAAY;MFu4BhB;IEv4BoC;IAEvD;MAC0B,gCAAG;MAAP,+BAAG;MAAhB,kBAAY;IADf;IFq4BN;MAAA,cAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,OAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,qBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,qBAAmB;MAAnB,mBAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,2BAAmB;MAAnB,6DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,oBAAmB;MAAnB,0BAAmB;IAAA;IAAnB;MAAA,qBAAmB;MAAnB,sDAAmB;IAAA;IAAnB;MAAA,iBAAmB;MAAnB,iBAAmB;MAAnB,iBAAmB;MAAnB,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,OAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,qBAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;IAAnB;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,wCAAmB;MAAnB,wDAAmB;MAAnB,qEAAmB;IAAA;IAAnB;MAAA,6BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,qBAAmB;IAAA;IAAnB;MAAA,0CAAmB;MAAnB,uBAAmB;IAAA;IAAnB;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,sBAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,sBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,2BAAmB;MAAnB,6DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,qBAAmB;MAAnB,sDAAmB;IAAA;IAAnB;MAAA,qBAAmB;MAAnB,sDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,iDAAmB;IAAA;IAAnB;MAAA,iDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,qEAAmB;MAAnB,6EAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,sBAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,+HAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;IAAnB;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,2BAAmB;MAAnB,6DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;EAAA;AADJ;AFp5BjB;EAEE;;IAEE,eAAgB;EACjB;AACF;AAkDD;EACE,aAAc;EACd,gBAAiB;AAClB;AAGD;EACE,oBAAqB;AACtB;AAGD;EACE,iCAAkC;AACnC;AACD;EACE,iCAAkC;AACnC;AACD;EACE,iCAAkC;AACnC;AArGD;EAAA;IAAA,gBAA6B;IAA7B,sBAA6B;IAA7B,wCAA6B;IAA7B,iBAA6B;IAA7B,kBAA6B;IAA7B,mBAA6B;IAA7B,sBAA6B;IAA7B,sBAA6B;IAA7B,qBAA6B;IAA7B,eAA6B;IAA7B,mBAA6B;IAA7B,sBAA6B;IAA7B;MAAA,8BAA6B;MAA7B,mBAA6B;MAA7B,4CAA6B;MAA7B,2BAA6B;MAA7B,4BAA6B;MAA7B,2CAA6B;MAA7B,2GAA6B;MAA7B,yGAA6B;MAA7B,iFAA6B;MAA7B,wCAA6B;IAAA;EAAA;EAA7B;IAAA,iCAA6B;IAA7B,UAA6B;EAAA;EAA7B;IAAA,UAA6B;EAAA;EAA7B;IAAA,iBAA6B;IAA7B,mBAA6B;EAAA;EAA7B;IAAA,oBAA6B;EAAA;EAA7B;IAAA,cAA6B;IAA7B,iBAA6B;EAAA;EAA7B;IAAA,0DAA6B;IAA7B,wCAA6B;IAA7B,4BAA6B;IAA7B,4BAA6B;IAA7B,qBAA6B;IAA7B,yBAA6B;EAAA;EAA7B;IAAA,yBAA6B;IAA7B,4BAA6B;IAA7B,wBAA6B;IAA7B,wBAA6B;IAA7B,sBAA6B;IAA7B,yBAA6B;EAAA;EAA7B;IAAA,gBAA6B;IAA7B,UAA6B;IAA7B,yBAA6B;IAA7B,qBAA6B;IAA7B,sBAA6B;IAA7B,6BAA6B;IAA7B,iBAA6B;IAA7B,cAA6B;IAA7B,YAA6B;IAA7B,WAA6B;IAA7B,iCAA6B;IAA7B,sBAA6B;IAA7B,wCAA6B;IAA7B,iBAA6B;IAA7B,sBAA6B;EAAA;EAA7B;IAAA,kBAA6B;EAAA;EAA7B;IAAA,mBAA6B;EAAA;EAA7B;IAAA,8BAA6B;IAA7B,mBAA6B;IAA7B,4CAA6B;IAA7B,2BAA6B;IAA7B,4BAA6B;IAA7B,2CAA6B;IAA7B,2GAA6B;IAA7B,yGAA6B;IAA7B,iFAA6B;EAAA;EAA7B;IAAA,yBAA6B;IAA7B,8BAA6B;IAA7B,0BAA6B;IAA7B,2BAA6B;IAA7B,4BAA6B;EAAA;EAA7B;IAAA,0DAA6B;IAA7B;MAAA,gBAA6B;IAAA;EAAA;EAA7B;IAAA,0DAA6B;IAA7B;MAAA,gBAA6B;IAAA;EAAA;EAA7B;IAAA,yBAA6B;IAA7B,8BAA6B;EAAA;EAA7B;IAAA,0DAA6B;IAA7B,yBAA6B;IAA7B,8BAA6B;IAA7B,0BAA6B;IAA7B,2BAA6B;IAA7B,4BAA6B;IAA7B;MAAA,gBAA6B;IAAA;EAAA;EAA7B;IAAA,yBAA6B;IAA7B,8BAA6B;EAAA;EAA7B;IAAA,iBAA6B;IAA7B,qBAA6B;IAA7B,eAA6B;IAA7B,gBAA6B;IAA7B,UAA6B;IAA7B,gBAA6B;IAA7B,oBAA6B;EAAA;EAA7B;IAAA,6BAA6B;IAA7B,0CAA6B;EAAA;AAAA;AA2DlB;EAAA,WAAQ;EAAR,eAAQ;EAAR,oBAAQ;AAAA;AAAqB;EAAA,WAAS;EAAT,eAAS;AAAA;AIZxC;EAAA,WAAG;EAAH,eAAG;EAAH,gBAAG;AAAA;AFg4BV;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AEj6B+J;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,sBAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,sBAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,kBAAY;EAAZ,eAAY;EAAZ,kBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,mBAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;EAAZ,wBAAY;AAAA;AFi6B9L;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,iBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAhfjB;EACE;IACE,yBAAyB;EADxB;AADW;AFvblB;EACE;;;IAGE,mBAAoB;IACpB,iBAAkB;EACnB;EACD;IACE,qBAAsB;IACtB,iBAAkB;EACnB;EACD;IACE,qBAAsB;IACtB,iBAAkB;EACnB;AACF;AAoCQ;EAAA;IAAA;MAAA,wBAAQ;MAAqB,yBAAS;MIZxC,uBAAG;MFg4BV,wBAAmB;MAAnB,wBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,sCAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MEj6B+J,sBAAY;MAAZ,0BAAY;MAAZ,uBAAY;MAAZ,4BAAY;MAAZ,gCAAY;MAAZ,6BAAY;MAAZ,wBAAY;MAAZ,2BAAY;MAAZ,8BAAY;MAAZ,iCAAY;MAAZ,wBAAY;MAAZ,2BAAY;MAAZ,4BAAY;MAAZ,kCAAY;MFi6B9L,+BAAmB;MAAnB,yBAAmB;MAAnB,wBAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;IFp3BF;EAAA;AAAA","sourcesContent":[null,"@import '@bcgov/bc-sans/css/BCSans.css' layer(base);\n@import 'tailwindcss';\n@import './buttons.css';\n@import './colors.css';\n\n@plugin \"@tailwindcss/forms\";\n\n@theme {\n  --font-sans: 'BCSans', sans-serif;\n\n  /* Theme Animations */\n  --animate-pulse-blur: pulse-blur 2.5s linear infinite;\n\n  @keyframes pulse-blur {\n    0%,\n    50%,\n    100% {\n      transform: scale(1);\n      filter: blur(0px);\n    }\n    25% {\n      transform: scale(0.6);\n      filter: blur(2px);\n    }\n    75% {\n      transform: scale(1.4);\n      filter: blur(2px);\n    }\n  }\n}\n\n@layer base {\n  /* Default cursor for buttons */\n  button:not(:disabled),\n  [role='button']:not(:disabled) {\n    cursor: pointer;\n  }\n}\n\n@utility ql-video {\n  @apply w-full h-96;\n}\n\n@utility inline-url {\n  @apply text-blue-600 visited:text-purple-600 underline underline-offset-2;\n}\n\n@utility breakAfter {\n  page-break-after: always;\n}\n\n@utility point-up {\n  clip-path: polygon(50% 0, 100% 100%, 0 100%);\n}\n\n@utility point-down {\n  clip-path: polygon(50% 100%, 0% 0%, 100% 0%);\n}\n\n@utility wysiwyg {\n  /* Styling for Wysiwyg Fields */\n  @apply text-left;\n\n  & h2 {\n    @apply border-b border-charcoal-500 font-bold my-6 py-5 text-2xl text-blumine-800;\n  }\n  & h3 {\n    @apply font-bold my-4 text-xl text-blumine-800;\n  }\n  & ol {\n    @apply list-decimal pl-6;\n  }\n  & ul {\n    @apply list-disc pl-6;\n  }\n  & div {\n    @apply my-4;\n  }\n  & p {\n    @apply my-4;\n  }\n  & a {\n    @apply inline-url;\n  }\n}\n\n/* Prevent blue focus outline in tiptap editor */\n.wysiwyg .ProseMirror:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n/* Prevent clickable links while editing in tiptap editor */\n.wysiwyg .ProseMirror a {\n  pointer-events: none;\n}\n\n/* Ensure Uppy uses BCSans */\n.uppy-Root {\n  font-family: 'BCSans', sans-serif;\n}\n.uppy-Root label {\n  font-family: 'BCSans', sans-serif;\n}\n.uppy-Root .uppy-u-reset {\n  font-family: 'BCSans', sans-serif;\n}\n","@font-face {\n  font-family: \"BCSans\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-Regular.woff2\") format(\"woff2\"), url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"BCSans\";\n  font-style: italic;\n  font-weight: 400;\n  src: url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-Italic.woff2\") format(\"woff2\"), url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-Italic.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"BCSans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-Bold.woff2\") format(\"woff2\"), url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"BCSans\";\n  font-style: italic;\n  font-weight: 700;\n  src: url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-BoldItalic.woff2\") format(\"woff2\"), url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-BoldItalic.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"BCSans\";\n  font-style: normal;\n  font-weight: 300;\n  src: url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-Light.woff2\") format(\"woff2\"), url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-Light.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"BCSans\";\n  font-style: italic;\n  font-weight: 300;\n  src: url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-LightItalic.woff2\") format(\"woff2\"), url(\"../../node_modules/@bcgov/bc-sans/fonts/BCSans-LightItalic.woff\") format(\"woff\");\n}\n","@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n      \"Noto Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 none);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 none);\n    --color-neutral-100: oklch(97% 0 none);\n    --color-neutral-200: oklch(92.2% 0 none);\n    --color-neutral-300: oklch(87% 0 none);\n    --color-neutral-400: oklch(70.8% 0 none);\n    --color-neutral-500: oklch(55.6% 0 none);\n    --color-neutral-600: oklch(43.9% 0 none);\n    --color-neutral-700: oklch(37.1% 0 none);\n    --color-neutral-800: oklch(26.9% 0 none);\n    --color-neutral-900: oklch(20.5% 0 none);\n    --color-neutral-950: oklch(14.5% 0 none);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 none);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      -apple-system,\n      BlinkMacSystemFont,\n      \"Segoe UI\",\n      Roboto,\n      \"Helvetica Neue\",\n      \"Noto Sans\",\n      Arial,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring:where(:not(iframe)) {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@theme {\n  /* Core Colors */\n  --color-blumine-50: #f0f9fb;\n  --color-blumine-100: #daeef3;\n  --color-blumine-200: #badee7;\n  --color-blumine-300: #89c5d7;\n  --color-blumine-400: #52a3be;\n  --color-blumine-500: #3787a3;\n  --color-blumine-600: #306d8a;\n  --color-blumine-700: #2d5b72;\n  --color-blumine-800: #2c4c5e;\n  --color-blumine-900: #284151;\n  --color-blumine-950: #162936;\n\n  --color-scarlet-50: #fff0f1;\n  --color-scarlet-100: #ffdcdf;\n  --color-scarlet-200: #ffc0c6;\n  --color-scarlet-300: #ff949e;\n  --color-scarlet-400: #ff5665;\n  --color-scarlet-500: #ff2236;\n  --color-scarlet-600: #ff0219;\n  --color-scarlet-700: #d80013;\n  --color-scarlet-800: #b40212;\n  --color-scarlet-900: #920a16;\n  --color-scarlet-950: #510007;\n\n  --color-charcoal-50: #f5f5f6;\n  --color-charcoal-100: #e6e6e7;\n  --color-charcoal-200: #cfd0d2;\n  --color-charcoal-300: #aeafb2;\n  --color-charcoal-400: #85868b;\n  --color-charcoal-500: #6a6b70;\n  --color-charcoal-600: #5a5b60;\n  --color-charcoal-700: #4d4d51;\n  --color-charcoal-800: #434347;\n  --color-charcoal-900: #313133;\n  --color-charcoal-950: #252527;\n\n  --color-jade-50: #effaf6;\n  --color-jade-100: #d9f2e6;\n  --color-jade-200: #b6e4d1;\n  --color-jade-300: #86cfb5;\n  --color-jade-400: #53b494;\n  --color-jade-500: #2c876d;\n  --color-jade-600: #227962;\n  --color-jade-700: #1b6150;\n  --color-jade-800: #184d40;\n  --color-jade-900: #144036;\n  --color-jade-950: #0a241f;\n\n  --color-ochre-50: #fcf9ee;\n  --color-ochre-100: #f5edd0;\n  --color-ochre-200: #ebd99c;\n  --color-ochre-300: #e1c268;\n  --color-ochre-400: #daad45;\n  --color-ochre-500: #d1912f;\n  --color-ochre-600: #c37829;\n  --color-ochre-700: #995424;\n  --color-ochre-800: #7e4322;\n  --color-ochre-900: #68381f;\n  --color-ochre-950: #3b1c0d;\n}\n\n/* Color variables referencing other variables */\n@theme inline {\n  --color-wordsy-correct: var(--color-jade-500);\n  --color-wordsy-present: var(--color-ochre-600);\n\n  --color-phrase-color-100: var(--color-ochre-100);\n  --color-phrase-color-200: var(--color-ochre-200);\n  --color-phrase-color-500: var(--color-ochre-500);\n  --color-phrase-color-600: var(--color-ochre-600);\n  --color-phrase-color-700: var(--color-ochre-700);\n  --color-phrase-color-800: var(--color-ochre-800);\n  --color-phrase-color-900: var(--color-ochre-900);\n\n  --color-word-color-100: var(--color-jade-100);\n  --color-word-color-200: var(--color-jade-200);\n  --color-word-color-500: var(--color-jade-500);\n  --color-word-color-600: var(--color-jade-600);\n  --color-word-color-700: var(--color-jade-700);\n  --color-word-color-800: var(--color-jade-800);\n  --color-word-color-900: var(--color-jade-900);\n\n  --color-song-color-100: var(--color-scarlet-100);\n  --color-song-color-200: var(--color-scarlet-200);\n  --color-song-color-600: var(--color-scarlet-600);\n  --color-song-color-700: var(--color-scarlet-700);\n  --color-song-color-800: var(--color-scarlet-800);\n  --color-song-color-900: var(--color-scarlet-900);\n\n  --color-story-color-100: var(--color-blumine-100);\n  --color-story-color-200: var(--color-blumine-200);\n  --color-story-color-600: var(--color-blumine-600);\n  --color-story-color-700: var(--color-blumine-700);\n  --color-story-color-800: var(--color-blumine-800);\n  --color-story-color-900: var(--color-blumine-900);\n}\n\n/* Safelisting for dynamically generated type classes */\n@source inline(\"{focus:,}{text,bg,border,to,from,ring}-phrase-color-{100,200,500,600,700,800,900}\");\n@source inline(\"{focus:,}{text,bg,border,to,from,ring}-word-color-{100,200,500,600,700,800,900}\");\n@source inline(\"{focus:,}{text,bg,border,ring}-song-color-{100,200,500,600,700,800,900}\");\n@source inline(\"{focus:,}{text,bg,border,ring}-story-color-{100,200,500,600,700,800,900}\");\n","/* Button base class */\n@utility btn {\n  @apply rounded-lg inline-flex justify-center items-center space-x-2 disabled:pointer-events-none;\n}\n\n/* Button base class for icon only buttons */\n@utility btn-icon {\n  @apply rounded-lg inline-flex justify-center items-center disabled:pointer-events-none;\n\n  & svg {\n    @apply block align-middle w-full h-full p-0 m-0;\n  }\n}\n\n/* Button colors and borders */\n@utility btn-primary {\n  @apply bg-blumine-600 text-blumine-100 disabled:bg-charcoal-300 disabled:text-charcoal-50 hover:bg-blumine-800 focus:outline-hidden focus:ring-2 focus:ring-blumine-300;\n}\n@utility btn-secondary {\n  @apply bg-white border border-blumine-900 text-blumine-900 disabled:border-charcoal-300 disabled:text-charcoal-300 hover:bg-blumine-100 focus:bg-blumine-200 focus:outline-hidden focus:ring-2 focus:ring-blumine-900;\n}\n@utility btn-tertiary {\n  @apply bg-white border border-transparent text-blumine-900 disabled:text-charcoal-300 hover:bg-blumine-100 focus:bg-blumine-200 focus:outline-hidden focus:ring-2 focus:ring-blumine-900;\n}\n\n/* Button sizes */\n/* Combine with btn-primary, btn-secondary, or btn-tertiary */\n@utility btn-xs {\n  @apply btn py-1 px-2\n           text-xs h-7 /* Mobile and tablet 12px font */\n           xl:text-xs xl:min-w-24 xl:h-6; /* Desktop 12px font */\n  & svg {\n    @apply fill-current w-3 h-3; /* All ~12px */\n  }\n}\n@utility btn-sm {\n  @apply btn py-1.5 px-3\n           text-xs min-w-24 h-9 /* Mobile and tablet ~(88x36) 12px font */\n           xl:text-sm xl:min-w-32 xl:h-8; /* Desktop ~(120x32) 14px font */\n  & svg {\n    @apply fill-current w-4.5 h-4.5; /* All ~18px */\n  }\n}\n@utility btn-md {\n  @apply btn py-2 px-3\n           text-base min-w-32 h-11 /* Mobile and tablet ~(120x44) 16px font */\n           xl:text-base xl:min-w-40 xl:h-10; /* Desktop ~(160x40) 16px font */\n  & svg {\n    @apply fill-current w-5 h-5; /* All ~20px */\n  }\n}\n@utility btn-lg {\n  @apply btn py-2 px-3\n           text-base min-w-40 h-14 /* Mobile and tablet ~(160x52) 16px font */\n           xl:text-lg xl:min-w-52 xl:h-12; /* Desktop ~(200x48) 18px font */\n  & svg {\n    @apply fill-current w-6.5 h-6.5; /* All ~28px */\n  }\n}\n@utility btn-xl {\n  @apply btn py-3 px-5\n           text-lg min-w-52 h-16 /* Mobile and tablet ~(200x60) 18px font */\n           xl:text-xl xl:min-w-80 xl:h-14; /* Desktop ~(300x56) 22px font */\n  & svg {\n    @apply fill-current w-8 h-8; /* All ~32px */\n  }\n}\n\n/* Icon only button sizes */\n/* Combine with btn-primary, btn-secondary, or btn-tertiary */\n@utility btn-sm-icon {\n  @apply btn-icon\n           w-11 h-11 /* Mobile and tablet ~44x44 */\n           xl:w-8 xl:h-8; /* Desktop ~32x32 */\n  & svg {\n    @apply fill-current\n           w-5 h-5 /* Mobile and tablet ~20px */\n           xl:w-3 xl:h-3; /* Desktop ~12px */\n  }\n}\n@utility btn-md-icon {\n  @apply btn-icon\n           w-12 h-12 /* Mobile ~48x48 */\n           md:w-14 md:h-14 /* Tablet ~56x56 */\n           xl:w-10 xl:h-10; /* Desktop ~40x40 */\n  & svg {\n    @apply fill-current w-6 h-6; /* All ~24px */\n  }\n}\n@utility btn-lg-icon {\n  @apply btn-icon\n           w-14 h-14 /* Mobile ~56x56 */\n           md:w-16 md:h-16 /* Tablet ~64x64 */\n           xl:w-12 xl:h-12; /* Desktop ~48x48 */\n  & svg {\n    @apply fill-current w-7 h-7; /* All ~28px */\n  }\n}\n@utility btn-xl-icon {\n  @apply btn-icon\n           w-16 h-16 /* Mobile ~64x64 */\n           md:w-20 md:h-20 /* Tablet ~72x72 */\n           xl:w-14 xl:h-14 /* Desktop ~56x56 */;\n  & svg {\n    @apply fill-current w-8 h-8; /* All ~32px */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
